(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vgm-homepage-donate-shop"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sectionSelector = '.vgm-section-donate-shop';
  const instances = new WeakMap();
  const init = (section) => {
    if (!section || section.dataset.vgmInitialized === 'true') return;
    section.dataset.vgmInitialized = 'true';
    const lifetime = new AbortController();
    const imageTools = import('@theme/vgm-images');
    const foundationCleanups = [];
    const listen = (target, type, handler, options = {}) => {
      if (!target) return;
      target.addEventListener(type, handler, { ...options, signal: lifetime.signal });
    };
    const dispose = () => {
      lifetime.abort();
      foundationCleanups.splice(0).forEach((cleanup) => cleanup());
      delete section.dataset.vgmInitialized;
      instances.delete(section);
    };
    instances.set(section, dispose);
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const vgmHome = section.querySelector('[data-vgm-donation-settings]');
    const i18nNode = section.querySelector('[data-vgm-home-i18n]');
    const decodeTranslation = (value) => String(value).replace(
      /&(#x[0-9a-f]+|#\d+|amp|quot|apos|lt|gt);/gi,
      (entity, key) => {
        const named = { amp: '&', quot: '"', apos: "'", lt: '<', gt: '>' };
        if (!key.startsWith('#')) return named[key.toLowerCase()] || entity;
        const code = key[1].toLowerCase() === 'x'
          ? parseInt(key.slice(2), 16)
          : parseInt(key.slice(1), 10);
        return code > 0 && code <= 0x10ffff && !(code >= 0xd800 && code <= 0xdfff)
          ? String.fromCodePoint(code)
          : entity;
      }
    );
    let i18n = {};
    try {
      i18n = JSON.parse(i18nNode?.textContent || '{}', (key, value) =>
        typeof value === 'string' ? decodeTranslation(value) : value
      );
    } catch (error) {
      i18n = {};
    }
    const formatI18n = (template, values = {}) => Object.entries(values).reduce(
      (output, [key, value]) => output.replaceAll(`__${String(key).toUpperCase()}__`, String(value ?? '')),
      String(template || '')
    );
    const categoryLabel = (tag) => i18n.categories?.[String(tag || '').trim()] || String(tag || '').trim();
    const supportEmail = vgmHome?.dataset.vgmSupportEmail || 'support@virtualgivingmachine.com';
    const matchCampaignEnabled = vgmHome?.dataset.vgmMatchEnabled !== 'false';
    const matchVariantId = String(vgmHome?.dataset.vgmMatchVariantId || '');
    const checkoutMatchEnabled = matchCampaignEnabled
      && vgmHome?.dataset.vgmCheckoutMatchEnabled === 'true'
      && Boolean(matchVariantId);
    const styleControls = vgmHome ? getComputedStyle(vgmHome) : null;
    const readControl = (name, fallback) => {
      if (!styleControls) return fallback;
      const value = parseFloat(styleControls.getPropertyValue(name));
      return Number.isFinite(value) ? value : fallback;
    };

    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const fitProductCopy = (copy) => {
      if (!copy) return;
      const title = copy.querySelector('.vgm-product-title');
      const price = copy.querySelector('.vgm-product-price');
      if (!title || !price) return;

      title.style.removeProperty('font-size');
      price.style.removeProperty('font-size');
      const configuredTitleStyles = getComputedStyle(title);
      const configuredLineClamp = parseInt(
        configuredTitleStyles.webkitLineClamp || configuredTitleStyles.lineClamp || '3',
        10
      );
      const maximumTitleLines = Number.isFinite(configuredLineClamp) && configuredLineClamp > 0
        ? configuredLineClamp
        : 3;
      copy.classList.add('vgm-fit-measuring');

      const titleBase = parseFloat(getComputedStyle(title).fontSize) || 18;
      const priceBase = parseFloat(getComputedStyle(price).fontSize) || 20;
      const priceMinimum = Math.max(12, priceBase * 0.52);
      const titleMinimum = Math.max(12, titleBase * 0.76);

      const naturalLineCount = () => {
        const styles = getComputedStyle(title);
        const fontSize = parseFloat(styles.fontSize) || titleBase;
        const lineHeight = parseFloat(styles.lineHeight) || (fontSize * 0.92);
        const height = title.getBoundingClientRect().height;
        return Math.max(1, Math.round(height / lineHeight));
      };

      const fits = () => {
        const copyRect = copy.getBoundingClientRect();
        const priceRect = price.getBoundingClientRect();
        const titleRect = title.getBoundingClientRect();
        const titleDoesNotOverflowWord = title.scrollWidth <= title.clientWidth + 1;
        const horizontalFit = priceRect.right <= copyRect.right + 1 && titleRect.left >= copyRect.left - 1;
        return naturalLineCount() <= maximumTitleLines && horizontalFit && titleDoesNotOverflowWord;
      };

      let priceSize = priceBase;
      while (!fits() && priceSize > priceMinimum) {
        priceSize = Math.max(priceMinimum, priceSize - 0.5);
        price.style.fontSize = `${priceSize}px`;
      }

      if (!fits()) {
        let titleSize = titleBase;
        while (!fits() && titleSize > titleMinimum) {
          titleSize = Math.max(titleMinimum, titleSize - 0.5);
          title.style.fontSize = `${titleSize}px`;
        }
      }

      copy.classList.remove('vgm-fit-measuring');
    };

    const fitAllProductCopy = () => {
      section.querySelectorAll('.vgm-product-card:not([hidden]) .vgm-product-copy').forEach(fitProductCopy);
    };

    let productCopyFitFrame = 0;
    const scheduleProductCopyFit = () => {
      if (productCopyFitFrame) cancelAnimationFrame(productCopyFitFrame);
      productCopyFitFrame = requestAnimationFrame(() => {
        productCopyFitFrame = 0;
        fitAllProductCopy();
      });
    };

    foundationCleanups.push(() => cancelAnimationFrame(productCopyFitFrame));
    scheduleProductCopyFit();
    listen(window, 'resize', scheduleProductCopyFit, { passive: true });
    listen(window, 'load', scheduleProductCopyFit, { once: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleProductCopyFit).catch(() => {});
    }

    const initCatalogTools = () => {
      const tools = section.querySelector('[data-vgm-catalog-tools]');
      const catalog = section.querySelector('[data-vgm-product-catalog]');
      if (!tools || !catalog) return;

      const cards = Array.from(catalog.querySelectorAll('.vgm-product-card'));
      if (!cards.length) {
        tools.hidden = true;
        return;
      }

      const searchInput = tools.querySelector('[data-vgm-catalog-search]');
      const searchClear = tools.querySelector('[data-vgm-catalog-search-clear]');
      const categorySelect = tools.querySelector('[data-vgm-catalog-category]');
      const sortSelect = tools.querySelector('[data-vgm-catalog-sort]');
      const countLabel = tools.querySelector('[data-vgm-catalog-count]');
      const viewToggle = tools.querySelector('.vgm-catalog-view-toggle');
      const viewButtons = Array.from(tools.querySelectorAll('[data-vgm-catalog-view]'));
      const resetButtons = Array.from(section.querySelectorAll('[data-vgm-catalog-reset]'));
      const emptyState = catalog.querySelector('[data-vgm-catalog-empty]');
      const hiddenPool = document.createElement('div');
      hiddenPool.className = 'vgm-catalog-hidden-pool';
      hiddenPool.hidden = true;

      const normalize = (value) => String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

      const tagsFor = (card) => String(card.dataset.productTags || '')
        .split('||')
        .map((tag) => tag.trim())
        .filter(Boolean);

      // Shopify product tags are the catalog categories. A product can belong to
      // any number of tag categories while still appearing under All Items.
      const categoryValueFor = (tag) => encodeURIComponent(String(tag || '').trim().toLocaleLowerCase());
      const categoryEntries = new Map();

      cards.forEach((card, index) => {
        if (card.dataset.productOutsourced === 'true') {
          const inquiryLink = card.querySelector('a[href^="mailto:"]');
          const inquirySource = card.querySelector('[data-vgm-modal-mailto-source]');
          if (inquiryLink) {
            const mailto = new URL(inquiryLink.href);
            ['subject', 'body'].forEach((key) => {
              const value = mailto.searchParams.get(key);
              if (value !== null) mailto.searchParams.set(key, decodeTranslation(value));
            });
            inquiryLink.href = mailto.toString();
            if (inquirySource) inquirySource.textContent = mailto.toString();
          }
        }
        const title = String(card.dataset.productTitle || card.querySelector('.vgm-product-title')?.textContent || '');
        const description = String(card.querySelector('[data-vgm-modal-description-source]')?.textContent || '');
        const tags = tagsFor(card);
        const categoryValues = new Set();
        const listCategory = card.querySelector('[data-vgm-list-category]');

        tags.forEach((tag) => {
          const rawLabel = String(tag || '').trim();
          const label = categoryLabel(rawLabel);
          const value = categoryValueFor(rawLabel);
          if (!rawLabel || !value || categoryValues.has(value)) return;
          categoryValues.add(value);

          const existing = categoryEntries.get(value);
          if (existing) existing.count += 1;
          else categoryEntries.set(value, { label, count: 1 });
        });

        card.dataset.vgmCatalogIndex = String(Number(card.dataset.productIndex) || index);
        card.dataset.vgmCatalogCategories = Array.from(categoryValues).join('||');
        card.dataset.vgmCatalogTitle = normalize(title);
        card.dataset.vgmCatalogSearch = normalize([title, description, ...tags, ...tags.map(categoryLabel)].join(' '));
        if (listCategory) listCategory.textContent = tags.map(categoryLabel).join(', ');
      });

      const createSelectOption = (value, label, displayLabel = label) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        option.dataset.vgmDropdownDisplay = displayLabel;
        return option;
      };

      if (categorySelect) {
        categorySelect.replaceChildren(createSelectOption('all', i18n.allItems || ''));
        Array.from(categoryEntries.entries())
          .sort(([, a], [, b]) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base', numeric: true }))
          .forEach(([value, category]) => {
            categorySelect.append(
              createSelectOption(value, `${category.label} (${category.count})`, category.label)
            );
          });
        window.VGMLiquidDropdown?.refresh?.(categorySelect);
      }

      const validViews = new Set(['large', 'small']);
      const validSorts = new Set(['featured', 'title-asc', 'title-desc', 'price-asc', 'price-desc']);
      const requestedView = String(tools.dataset.defaultView || 'large');
      const requestedSort = String(tools.dataset.defaultSort || 'featured');
      const state = {
        query: '',
        category: 'all',
        view: validViews.has(requestedView) ? requestedView : 'large',
        sort: validSorts.has(requestedSort) ? requestedSort : 'featured'
      };

      const indexFor = (card) => Number(card.dataset.vgmCatalogIndex) || 0;
      const titleFor = (card) => String(card.dataset.productTitle || '').trim();
      const priceFor = (card) => {
        if (card.dataset.productOutsourced === 'true') return null;
        const price = Number(card.dataset.productPrice);
        return Number.isFinite(price) ? price : null;
      };

      const sortedCards = (items) => [...items].sort((a, b) => {
        const fallback = indexFor(a) - indexFor(b);
        if (state.sort === 'featured') return fallback;
        if (state.sort === 'title-asc' || state.sort === 'title-desc') {
          const direction = state.sort === 'title-desc' ? -1 : 1;
          return direction * titleFor(a).localeCompare(titleFor(b), undefined, {
            sensitivity: 'base',
            numeric: true
          }) || fallback;
        }
        const aPrice = priceFor(a);
        const bPrice = priceFor(b);
        if (aPrice === null && bPrice === null) return fallback;
        if (aPrice === null) return 1;
        if (bPrice === null) return -1;
        const direction = state.sort === 'price-desc' ? -1 : 1;
        return direction * (aPrice - bPrice) || fallback;
      });

      const largeRowSizes = (count) => {
        // Nine cards are a deliberate VGM large-grid composition:
        // 2, 3, 2, 2. Keep the three-card row directly after the
        // opening two-card row instead of pushing it to the bottom.
        if (count === 9) return [2, 3, 2, 2];

        const rows = [];
        let cycles = Math.floor(count / 8);
        let remainder = count % 8;
        if (remainder === 1 && cycles > 0) {
          cycles -= 1;
          remainder += 8;
        }
        for (let index = 0; index < cycles; index += 1) rows.push(2, 3, 3);
        const tails = {
          0: [], 1: [1], 2: [2], 3: [3], 4: [2, 2], 5: [2, 3],
          6: [3, 3], 7: [2, 2, 3], 9: [2, 3, 2, 2]
        };
        return rows.concat(tails[remainder] || []);
      };

      const catalogCapacity = () => {
        const styles = getComputedStyle(catalog);
        const gap = Math.max(0, parseFloat(styles.getPropertyValue('--vgm-layout-capacity-gap')) || 0);
        const minimum = Math.max(1, parseFloat(styles.getPropertyValue('--vgm-layout-card-min-width')) || 150);
        const limit = Math.max(1, Math.min(3, parseInt(styles.getPropertyValue('--vgm-layout-catalog-max-columns'), 10) || 3));
        const width = catalog.clientWidth;
        return Math.max(1, Math.min(limit, Math.floor((width + gap) / (minimum + gap))));
      };
      const uniformRowSizes = (count, columns) => {
        const rows = [];
        for (let remaining = count; remaining > 0; remaining -= columns) {
          rows.push(Math.min(columns, remaining));
        }
        return rows;
      };
      const rowSizes = (count) => {
        const capacity = catalogCapacity();
        catalog.dataset.capacity = String(capacity);
        if (state.view === 'small' || capacity < 3) return uniformRowSizes(count, capacity);
        return largeRowSizes(count);
      };

      if (categorySelect) {
        categorySelect.value = state.category;
        window.VGMLiquidDropdown?.refresh?.(categorySelect);
      }
      if (sortSelect) {
        sortSelect.value = state.sort;
        window.VGMLiquidDropdown?.refresh?.(sortSelect);
      }

      const updateControlState = (visibleCount) => {
        viewButtons.forEach((button) => {
          const active = button.dataset.vgmCatalogView === state.view;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        const viewAvailable = catalogCapacity() >= 3;
        tools.dataset.viewAvailable = String(viewAvailable);
        if (viewToggle) {
          viewToggle.dataset.activeView = state.view;
          viewToggle.hidden = !viewAvailable;
        }

        const hasQuery = Boolean(state.query);
        const hasCategory = state.category !== 'all';
        if (searchClear) searchClear.hidden = !hasQuery;
        resetButtons.forEach((button) => {
          const isEmptyStateButton = button.closest('[data-vgm-catalog-empty]');
          button.hidden = isEmptyStateButton ? visibleCount > 0 : !(hasQuery || hasCategory);
        });
        if (countLabel) {
          countLabel.textContent = visibleCount === cards.length
            ? formatI18n(cards.length === 1 ? i18n.itemCountOne : i18n.itemCountMany, { count: cards.length })
            : formatI18n(i18n.visibleItemCount, { visible: visibleCount, total: cards.length });
        }
      };

      const animateCardToPlace = (card, previousRect, index) => {
        if (reducedMotionQuery.matches || typeof card.animate !== 'function') return;
        const nextRect = card.getBoundingClientRect();
        if (previousRect) {
          const x = previousRect.left - nextRect.left;
          const y = previousRect.top - nextRect.top;
          const scaleX = nextRect.width ? previousRect.width / nextRect.width : 1;
          const scaleY = nextRect.height ? previousRect.height / nextRect.height : 1;
          card.animate([
            { transform: `translate3d(${x}px,${y}px,0) scale(${scaleX},${scaleY})`, opacity: .82 },
            { transform: 'translate3d(0,0,0) scale(1,1)', opacity: 1 }
          ], {
            duration: 560,
            delay: Math.min(index * 14, 112),
            easing: 'cubic-bezier(.16,1,.3,1)'
          });
        } else {
          card.animate([
            { transform: 'translate3d(0,16px,0) scale(.975)', opacity: 0 },
            { transform: 'translate3d(0,0,0) scale(1)', opacity: 1 }
          ], {
            duration: 460,
            delay: Math.min(index * 18, 126),
            easing: 'cubic-bezier(.16,1,.3,1)'
          });
        }
      };

      const rebuildCatalog = (visibleCards, previousRects = new Map(), previousHeight = 0, animate = true) => {
        const visibleSet = new Set(visibleCards);
        const fragment = document.createDocumentFragment();
        const sizes = rowSizes(visibleCards.length);
        let cursor = 0;

        sizes.forEach((size) => {
          const row = document.createElement('div');
          const rowColumns = state.view === 'small' ? catalogCapacity() : size;
          row.className = `vgm-product-row ${rowColumns === 3 ? 'is-three' : rowColumns === 2 ? 'is-two' : 'is-one'}`;
          row.style.setProperty('--vgm-row-columns', String(rowColumns));
          row.dataset.vgmCatalogRow = '';
          for (let index = 0; index < size; index += 1) {
            const card = visibleCards[cursor];
            cursor += 1;
            if (!card) continue;
            card.hidden = false;
            card.classList.remove('is-large', 'is-small', 'is-list');
            if (state.view === 'small' || size === 3) card.classList.add('is-small');
            else card.classList.add('is-large');
            row.append(card);
          }
          fragment.append(row);
        });

        hiddenPool.replaceChildren();
        cards.forEach((card) => {
          if (visibleSet.has(card)) return;
          card.hidden = true;
          hiddenPool.append(card);
        });

        catalog.replaceChildren(fragment, hiddenPool);
        if (emptyState) {
          emptyState.hidden = visibleCards.length > 0;
          catalog.append(emptyState);
        }
        catalog.dataset.view = state.view;
        catalog.setAttribute('aria-busy', 'false');

        const nextHeight = catalog.getBoundingClientRect().height;
        if (animate && !reducedMotionQuery.matches && previousHeight > 0 && Math.abs(nextHeight - previousHeight) > 1 && typeof catalog.animate === 'function') {
          catalog.animate([
            { height: `${previousHeight}px` },
            { height: `${nextHeight}px` }
          ], {
            duration: 520,
            easing: 'cubic-bezier(.16,1,.3,1)'
          });
        }
        if (animate) visibleCards.forEach((card, index) => animateCardToPlace(card, previousRects.get(card), index));
        updateControlState(visibleCards.length);
        scheduleProductCopyFit();
      };

      let transitionTimer = 0;
      let transitionRevision = 0;
      const cancelCatalogMotion = () => {
        cards.forEach((card) => card.getAnimations?.().forEach((animation) => animation.cancel()));
        catalog.getAnimations?.().forEach((animation) => animation.cancel());
      };

      const applyCatalogState = ({ animate = true } = {}) => {
        window.clearTimeout(transitionTimer);
        transitionRevision += 1;
        const revision = transitionRevision;
        cancelCatalogMotion();

        const queryTokens = normalize(state.query).split(' ').filter(Boolean);
        const matchingCards = cards.filter((card) => {
          const matchesQuery = queryTokens.every((token) => String(card.dataset.vgmCatalogSearch || '').includes(token));
          const cardCategories = String(card.dataset.vgmCatalogCategories || '').split('||').filter(Boolean);
          const matchesCategory = state.category === 'all' || cardCategories.includes(state.category);
          return matchesQuery && matchesCategory;
        });
        const titleMatches = (card) => queryTokens.every((token) => String(card.dataset.vgmCatalogTitle || '').includes(token));
        const visible = queryTokens.length
          ? [
              ...sortedCards(matchingCards.filter(titleMatches)),
              ...sortedCards(matchingCards.filter((card) => !titleMatches(card)))
            ]
          : sortedCards(matchingCards);

        const previousCards = cards.filter((card) => !card.hidden);
        const previousRects = new Map(previousCards.map((card) => [card, card.getBoundingClientRect()]));
        const previousHeight = catalog.getBoundingClientRect().height;
        const nextSet = new Set(visible);
        const exiting = previousCards.filter((card) => !nextSet.has(card));

        const mutate = () => {
          if (revision !== transitionRevision) return;
          cancelCatalogMotion();
          rebuildCatalog(visible, previousRects, previousHeight, animate);
        };

        if (animate && !reducedMotionQuery.matches && exiting.length && typeof exiting[0].animate === 'function') {
          catalog.setAttribute('aria-busy', 'true');
          exiting.forEach((card, index) => card.animate([
            { transform: 'translate3d(0,0,0) scale(1)', opacity: 1 },
            { transform: 'translate3d(0,-8px,0) scale(.97)', opacity: 0 }
          ], {
            duration: 180,
            delay: Math.min(index * 10, 50),
            easing: 'cubic-bezier(.4,0,1,1)',
            fill: 'forwards'
          }));
          transitionTimer = window.setTimeout(mutate, 205);
        } else {
          mutate();
        }
      };

      if (categorySelect) {
        categorySelect.addEventListener('change', () => {
          state.category = categorySelect.value || 'all';
          applyCatalogState();
        });
      }

      if (sortSelect) {
        sortSelect.addEventListener('change', () => {
          const requested = String(sortSelect.value || 'featured');
          state.sort = validSorts.has(requested) ? requested : 'featured';
          if (sortSelect.value !== state.sort) sortSelect.value = state.sort;
          window.VGMLiquidDropdown?.refresh?.(sortSelect);
          applyCatalogState();
        });
      }

      let searchTimer = 0;
      if (searchInput) {
        searchInput.addEventListener('input', () => {
          state.query = searchInput.value.trim();
          if (searchClear) searchClear.hidden = !state.query;
          window.clearTimeout(searchTimer);
          searchTimer = window.setTimeout(() => applyCatalogState(), 95);
        });
        searchInput.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !searchInput.value) return;
          event.preventDefault();
          searchInput.value = '';
          state.query = '';
          applyCatalogState();
        });
      }

      if (searchClear) {
        searchClear.addEventListener('click', () => {
          if (searchInput) {
            searchInput.value = '';
            searchInput.focus();
          }
          state.query = '';
          applyCatalogState();
        });
      }

      viewButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const view = String(button.dataset.vgmCatalogView || '');
          if (!validViews.has(view) || view === state.view) return;
          state.view = view;
          viewToggle?.classList.add('is-manipulating');
          window.setTimeout(() => viewToggle?.classList.remove('is-manipulating'), 480);
          applyCatalogState();
        });
      });

      resetButtons.forEach((button) => {
        button.addEventListener('click', () => {
          state.query = '';
          state.category = 'all';
          if (searchInput) searchInput.value = '';
          if (categorySelect) {
            categorySelect.value = 'all';
            window.VGMLiquidDropdown?.refresh?.(categorySelect);
          }
          applyCatalogState();
          if (searchInput) searchInput.focus({ preventScroll: true });
        });
      });

      applyCatalogState({ animate: false });
      let previousCapacity = catalogCapacity();
      let capacityFrame = 0;
      const scheduleCapacityCheck = () => {
        if (capacityFrame) return;
        capacityFrame = requestAnimationFrame(() => {
          capacityFrame = 0;
          if (!section.isConnected) return;
          const nextCapacity = catalogCapacity();
          if (nextCapacity !== previousCapacity) {
            previousCapacity = nextCapacity;
            applyCatalogState({ animate: false });
          }
          scheduleProductCopyFit();
        });
      };
      const catalogObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleCapacityCheck) : null;
      catalogObserver?.observe(catalog);
      listen(window, 'resize', scheduleCapacityCheck, { passive: true });
      foundationCleanups.push(() => {
        catalogObserver?.disconnect();
        cancelAnimationFrame(capacityFrame);
        window.removeEventListener('resize', scheduleCapacityCheck);
        clearTimeout(transitionTimer);
        clearTimeout(searchTimer);
      });
    };

    initCatalogTools();

    const productModal = section.querySelector('[data-vgm-product-modal]');
    const productModalCard = section.querySelector('[data-vgm-product-modal-card]');
    const productModalScroll = section.querySelector('[data-vgm-product-modal-scroll]');
    const productModalDetails = section.querySelector('.vgm-product-modal-details');
    const productModalMedia = section.querySelector('.vgm-product-modal-media');
    const productModalFooter = section.querySelector('[data-vgm-product-modal-footer]');
    const productModalQtyWrap = section.querySelector('[data-vgm-product-modal-qty-wrap]');
    const productModalImage = section.querySelector('[data-vgm-product-modal-image]');
    const productModalTitle = section.querySelector('[data-vgm-product-modal-title]');
    const productModalPrice = section.querySelector('[data-vgm-product-modal-price]');
    const productModalVariantPicker = section.querySelector('[data-vgm-product-modal-variant-picker]');
    const productModalVariantList = section.querySelector('[data-vgm-product-modal-variant-list]');
    const productModalDescription = section.querySelector('[data-vgm-product-modal-description]');
    const productModalQtyNumber = section.querySelector('[data-vgm-product-modal-qty-number]');
    const productModalDecrease = section.querySelector('[data-vgm-product-modal-decrease]');
    const productModalIncrease = section.querySelector('[data-vgm-product-modal-increase]');
    const productModalAdd = section.querySelector('[data-vgm-product-modal-add]');
    const productModalInquiry = section.querySelector('[data-vgm-product-modal-inquiry]');
    const productModalInquiryLink = section.querySelector('[data-vgm-product-modal-inquiry-link]');
    const productModalClose = section.querySelector('[data-vgm-product-modal-close]');
    const productModalCloseButton = section.querySelector('[data-vgm-product-modal-close-button]');

    let activeModalVariantId = null;
    let activeModalSourceCard = null;
    let activeModalProductTitle = '';
    let activeModalVariantTitle = '';
    let activeModalVariants = [];
    let activeModalDefaultImage = '';
    let activeModalIsOutsourced = false;
    let activeModalInquiryMailto = '';
    let activeModalInquiryRole = '';
    let modalReturnFocus = null;
    let modalCloseTimer = 0;


    let modalLayoutFrame = 0;
    const updateModalLayout = () => {
      modalLayoutFrame = 0;
      if (!productModal?.classList.contains('is-open')) return;
      const compact = getComputedStyle(productModalScroll).display !== 'contents';
      if (compact) {
        productModalCard?.classList.remove('has-square-layout');
        productModalCard?.style.removeProperty('--vgm-modal-square-size');
        if (productModalCard && productModalFooter) {
          const modalStyles = getComputedStyle(productModal);
          const availableHeight = productModal.clientHeight
            - (parseFloat(modalStyles.paddingTop) || 0)
            - (parseFloat(modalStyles.paddingBottom) || 0);
          const neededHeight = productModalScroll.scrollHeight + productModalFooter.offsetHeight;
          const fittedHeight = `${Math.max(0, Math.min(availableHeight, neededHeight))}px`;
          if (productModalCard.style.getPropertyValue('--vgm-modal-fit-height') !== fittedHeight) {
            productModalCard.style.setProperty('--vgm-modal-fit-height', fittedHeight);
          }
        }
      } else if (productModalCard && productModalMedia) {
        productModalCard.style.removeProperty('--vgm-modal-fit-height');
        const squareSize = Math.round(productModalMedia.offsetWidth);
        if (squareSize > 0) {
          const value = `${squareSize}px`;
          if (productModalCard.style.getPropertyValue('--vgm-modal-square-size') !== value) {
            productModalCard.style.setProperty('--vgm-modal-square-size', value);
          }
          productModalCard.classList.add('has-square-layout');
        }
      }
      const scroller = compact ? productModalScroll : productModalDetails;
      productModal.classList.toggle('has-scrollable-content', scroller.scrollHeight > scroller.clientHeight + 2);
      productModal.classList.toggle('is-content-scrolled', scroller.scrollTop > 1);
      const imageWidth = modalImageWidth();
      if (productModalImage && Math.abs(imageWidth - Number(productModalImage.dataset.displayWidth || 0)) > 2) {
        productModalImage.dataset.displayWidth = String(imageWidth);
        const variant = activeModalVariants.find(item => String(item.id) === activeModalVariantId);
        setModalImage(variant?.image || activeModalDefaultImage);
      }
    };
    const scheduleModalLayout = () => {
      if (!modalLayoutFrame) modalLayoutFrame = requestAnimationFrame(updateModalLayout);
    };
    const modalResizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleModalLayout) : null;
    [productModalCard, productModalScroll, productModalMedia, productModalDetails, productModalFooter, productModalDescription].forEach((node) => {
      if (node) modalResizeObserver?.observe(node);
    });
    [productModalScroll, productModalDetails].forEach((node) => node?.addEventListener('scroll', scheduleModalLayout, { passive: true }));
    listen(window, 'resize', scheduleModalLayout, { passive: true });
    listen(window.visualViewport, 'resize', scheduleModalLayout, { passive: true });
    foundationCleanups.push(() => {
      cancelAnimationFrame(modalLayoutFrame);
      modalResizeObserver?.disconnect();
      [productModalScroll, productModalDetails].forEach((node) => node?.removeEventListener('scroll', scheduleModalLayout));
      window.removeEventListener('resize', scheduleModalLayout);
      window.visualViewport?.removeEventListener('resize', scheduleModalLayout);
    });

    const modalImageWidth = () => Math.max(1, productModalMedia?.offsetWidth || Math.min(window.innerWidth - 48, 670));
    let modalImageRequest = 0;
    const setModalImage = async (source, alt = activeModalProductTitle) => {
      const request = ++modalImageRequest;
      const tools = await imageTools;
      if (request !== modalImageRequest || lifetime.signal.aborted || !productModalImage) return;
      return tools.swapImage(productModalImage, source, {
        width: modalImageWidth(), fallback: productModalImage.dataset.fallbackSrc,
        signal: lifetime.signal, animate: true, alt
      });
    };
    foundationCleanups.push(() => {
      modalImageRequest++;
      imageTools.then(tools => productModalImage && tools.cancelSwap(productModalImage));
    });
    const warmCardImages = async (card, limit = 2) => {
      if (!card) return;
      const tools = await imageTools;
      if (tools.limitedConnection() || lifetime.signal.aborted) return;
      const variants = readModalVariants(card);
      const sources = [readText(card, '[data-vgm-modal-photo-source]'), ...variants.map(variant => variant.image)];
      const seen = new Set();
      for (const source of [...new Set(sources.filter(Boolean))].slice(0, limit)) {
        if (lifetime.signal.aborted || tools.limitedConnection()) return;
        if (seen.has(source)) continue;
        seen.add(source);
        try { await tools.prepareImage(source, { width: modalImageWidth(), maximum: 1600 }); } catch {}
      }
    };
    let imageIntentTimer = 0;
    foundationCleanups.push(() => clearTimeout(imageIntentTimer));
    listen(section, 'pointerover', event => {
      const card = event.target.closest('.vgm-product-card');
      if (!card || card.contains(event.relatedTarget)) return;
      clearTimeout(imageIntentTimer);
      imageIntentTimer = setTimeout(() => { if (card.matches(':hover')) warmCardImages(card); }, 140);
    });
    listen(section, 'focusin', event => warmCardImages(event.target.closest('.vgm-product-card')));

    const readText = (card, selector) => {
      const node = card && card.querySelector(selector);
      return node ? node.textContent.trim() : '';
    };

    const readModalVariants = (card) => {
      const source = card && card.querySelector('[data-vgm-modal-variants-source]');
      if (!source) return [];
      try {
        const variants = JSON.parse(source.textContent || '[]');
        return Array.isArray(variants) ? variants : [];
      } catch (error) {
        console.warn('VGM variant data could not be read:', error);
        return [];
      }
    };

    const modalControlForVariant = (variantId) => {
      if (!activeModalSourceCard || !variantId) return null;
      return Array.from(activeModalSourceCard.querySelectorAll('[data-vgm-cart-control]')).find(
        (control) => String(control.dataset.variantId || '') === String(variantId)
      ) || null;
    };

    const activeModalItemLabel = () => {
      if (activeModalVariants.length <= 1 || !activeModalVariantTitle || activeModalVariantTitle === 'Default Title') {
        return activeModalProductTitle || i18n.itemGeneric || '';
      }
      return `${activeModalProductTitle} — ${activeModalVariantTitle}`;
    };

    const syncOutsourcedInquiryLink = (variant = null) => {
      if (!activeModalIsOutsourced || !productModalInquiryLink) return;
      const variantTitle = String(variant?.title || '').trim();
      const selectedRole = variantTitle && variantTitle !== 'Default Title'
        ? variantTitle
        : activeModalInquiryRole || activeModalProductTitle || i18n.outsourcedDefaultRole || '';
      const roleLabel = /outsourced employee/i.test(selectedRole)
        ? selectedRole
        : formatI18n(i18n.outsourcedEmployee, { role: selectedRole });
      let href = activeModalInquiryMailto || `mailto:${supportEmail}`;

      if (variantTitle && variantTitle !== 'Default Title') {
        const subject = formatI18n(i18n.inquirySubject, { role: roleLabel });
        const body = formatI18n(i18n.inquiryVariantBody, { role: roleLabel });
        href = `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      }

      productModalInquiryLink.href = href;
      productModalInquiryLink.setAttribute('aria-label', formatI18n(i18n.emailHiring, { role: roleLabel }));
    };

    const selectModalVariant = (variantId) => {
      const variant = activeModalVariants.find((item) => String(item.id) === String(variantId));
      if (!variant) return;

      activeModalVariantId = String(variant.id);
      activeModalVariantTitle = String(variant.title || '');
      productModal.dataset.selectedVariantId = activeModalVariantId;
      if (activeModalSourceCard) activeModalSourceCard.dataset.vgmSelectedVariantId = activeModalVariantId;

      if (productModalPrice) productModalPrice.textContent = String(variant.price || '');
      if (productModalImage) {
        const nextImage = String(variant.image || activeModalDefaultImage || productModalImage.dataset.fallbackSrc || '');
        if (nextImage) {
          productModalImage.dataset.fallbackApplied = 'false';
          setModalImage(nextImage);
        }
      }
      if (productModalVariantList) {
        productModalVariantList.querySelectorAll('[data-vgm-modal-variant-id]').forEach((pill) => {
          const selected = String(pill.dataset.vgmModalVariantId || '') === activeModalVariantId;
          pill.classList.toggle('is-selected', selected);
          pill.setAttribute('aria-checked', selected ? 'true' : 'false');
          pill.tabIndex = selected ? 0 : -1;
        });
      }

      if (activeModalIsOutsourced) {
        syncOutsourcedInquiryLink(variant);
        productModal.classList.remove('has-quantity', 'is-single', 'is-multi');
        return;
      }

      const control = modalControlForVariant(activeModalVariantId);
      const quantity = control ? Math.max(0, Number(control.dataset.cartQuantity) || 0) : 0;
      if (typeof pendingBagOpen !== 'undefined') pendingBagOpen.delete(activeModalVariantId);
      renderProductModalQuantity(activeModalVariantId, quantity);
    };

    const renderModalVariantPicker = (selectedVariantId) => {
      if (!productModal || !productModalVariantPicker || !productModalVariantList) return;
      productModalVariantList.replaceChildren();

      const showPicker = activeModalVariants.length > 1;
      productModal.classList.toggle('has-variants', showPicker);
      productModalVariantPicker.hidden = !showPicker;
      if (!showPicker) return;

      activeModalVariants.forEach((variant) => {
        const pill = document.createElement('button');
        const name = document.createElement('span');
        const price = document.createElement('span');
        const isSelected = String(variant.id) === String(selectedVariantId);

        pill.type = 'button';
        pill.className = `vgm-product-modal-variant-pill${isSelected ? ' is-selected' : ''}`;
        pill.dataset.vgmModalVariantId = String(variant.id);
        pill.setAttribute('role', 'radio');
        pill.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        pill.setAttribute(
          'aria-label',
          formatI18n(variant.available ? i18n.variantAvailable : i18n.variantUnavailable, {
            title: variant.title,
            price: variant.price
          })
        );
        pill.tabIndex = isSelected ? 0 : -1;
        pill.disabled = !variant.available;

        name.className = 'vgm-product-modal-variant-name';
        name.textContent = String(variant.title || i18n.option || '');
        price.className = 'vgm-product-modal-variant-price';
        price.textContent = String(variant.price || '');
        pill.append(name, price);
        productModalVariantList.append(pill);
      });
    };

    const setModalFlipOrigin = (sourceCard) => {
      if (!productModalCard || !sourceCard) return;
      const target = productModalCard.getBoundingClientRect();
      const source = sourceCard.getBoundingClientRect();
      if (!target.width || !target.height || !source.width || !source.height) return;

      const sourceCX = source.left + source.width / 2;
      const sourceCY = source.top + source.height / 2;
      const targetCX = target.left + target.width / 2;
      const targetCY = target.top + target.height / 2;

      productModalCard.style.setProperty('--vgm7-from-x', `${sourceCX - targetCX}px`);
      productModalCard.style.setProperty('--vgm7-from-y', `${sourceCY - targetCY}px`);
      productModalCard.style.setProperty('--vgm7-from-scale-x', String(Math.max(.02, source.width / target.width)));
      productModalCard.style.setProperty('--vgm7-from-scale-y', String(Math.max(.02, source.height / target.height)));
    };

    const pulseModalQuantity = () => {
      if (!productModalQtyNumber) return;
      productModalQtyNumber.classList.remove('is-changing');
      void productModalQtyNumber.offsetWidth;
      productModalQtyNumber.classList.add('is-changing');
      window.setTimeout(() => productModalQtyNumber.classList.remove('is-changing'), 360);
    };

    const renderProductModalQuantity = (variantId, quantity, { pulse = false } = {}) => {
      if (!productModal || String(variantId || '') !== String(activeModalVariantId || '')) return;
      const qty = Math.max(0, Number(quantity) || 0);
      const sourceControl = modalControlForVariant(activeModalVariantId);
      const available = sourceControl ? sourceControl.dataset.variantAvailable === 'true' : false;
      const itemLabel = activeModalItemLabel();

      productModal.classList.toggle('has-quantity', qty > 0);
      if (productModalQtyWrap) productModalQtyWrap.inert = qty <= 0;
      if (productModalAdd) {
        productModalAdd.tabIndex = qty > 0 ? -1 : 0;
        productModalAdd.setAttribute('aria-hidden', qty > 0 ? 'true' : 'false');
      }
      productModal.classList.toggle('is-single', qty === 1);
      productModal.classList.toggle('is-multi', qty > 1);

      if (productModalQtyNumber) productModalQtyNumber.textContent = String(qty || 1);
      if (productModalDecrease) {
        productModalDecrease.setAttribute(
          'aria-label',
          formatI18n(qty <= 1 ? i18n.removeFromBag : i18n.removeOneFromBag, { item: itemLabel })
        );
      }
      if (productModalIncrease) {
        productModalIncrease.disabled = !available;
        productModalIncrease.setAttribute('aria-label', formatI18n(i18n.addOneToBag, { item: itemLabel }));
      }
      if (productModalAdd) {
        productModalAdd.disabled = !available;
        productModalAdd.textContent = available ? i18n.addToBagUpper : i18n.unavailableUpper;
        productModalAdd.setAttribute(
          'aria-label',
          formatI18n(available ? i18n.addItemToBag : i18n.productUnavailable, { item: itemLabel })
        );
      }
      if (pulse && qty > 0) pulseModalQuantity();
    };

    const finalizeProductModalClose = () => {
      if (!productModal || !productModalCard) return;
      productModal.classList.remove('is-open', 'has-quantity', 'is-single', 'is-multi', 'is-outsourced', 'has-variants');
      productModal.setAttribute('aria-hidden', 'true');
      productModalCard.classList.remove('is-from-card', 'is-expanded');
      document.documentElement.classList.remove('vgm-product-modal-open');
      activeModalVariantId = null;
      activeModalSourceCard = null;
      activeModalProductTitle = '';
      activeModalVariantTitle = '';
      activeModalVariants = [];
      activeModalDefaultImage = '';
      activeModalIsOutsourced = false;
      activeModalInquiryMailto = '';
      activeModalInquiryRole = '';
      delete productModal.dataset.selectedVariantId;
      if (productModalVariantList) productModalVariantList.replaceChildren();
      if (productModalVariantPicker) productModalVariantPicker.hidden = true;
      if (productModalInquiryLink) {
        productModalInquiryLink.href = `mailto:${supportEmail}`;
        productModalInquiryLink.removeAttribute('aria-label');
      }
      productModalCard.style.transitionDuration = '';
      productModal.classList.remove('has-scrollable-content', 'is-content-scrolled');
      productModal.inert = true;
      if (modalReturnFocus && typeof modalReturnFocus.focus === 'function') {
        try { modalReturnFocus.focus({ preventScroll: true }); } catch (error) { modalReturnFocus.focus(); }
      }
      modalReturnFocus = null;
    };

    const closeProductModal = (immediate = false) => {
      if (!productModal || !productModal.classList.contains('is-open')) return;
      window.clearTimeout(modalCloseTimer);

      if (immediate || reducedMotionQuery.matches) {
        finalizeProductModalClose();
        return;
      }

      if (activeModalSourceCard && activeModalSourceCard.isConnected) {
        setModalFlipOrigin(activeModalSourceCard);
        productModalCard.classList.add('is-from-card');
        requestAnimationFrame(() => productModalCard.classList.remove('is-expanded'));
      } else {
        productModalCard.classList.remove('is-expanded');
      }
      productModal.classList.remove('is-open');

      const closeDuration = Math.max(120, readControl('--vgm7-modal-card-close-duration', 440));
      productModalCard.style.transitionDuration = `${closeDuration}ms, 220ms, ${closeDuration}ms`;
      modalCloseTimer = window.setTimeout(finalizeProductModalClose, closeDuration + 40);
    };

    const openProductModal = (card, trigger) => {
      if (!productModal || !productModalCard || !card) return;
      window.clearTimeout(modalCloseTimer);

      activeModalIsOutsourced = readText(card, '[data-vgm-modal-outsourced-source]') === 'true';
      activeModalSourceCard = card;
      activeModalProductTitle = readText(card, '[data-vgm-modal-title-source]');
      activeModalVariants = readModalVariants(card);

      const selectedVariantId = card.dataset.vgmSelectedVariantId || readText(card, '[data-vgm-modal-selected-variant-source]');
      const selectedVariant = activeModalVariants.find((variant) => String(variant.id) === String(selectedVariantId))
        || activeModalVariants.find((variant) => variant.available)
        || activeModalVariants[0]
        || null;
      activeModalVariantId = selectedVariant ? String(selectedVariant.id) : '';
      activeModalVariantTitle = selectedVariant ? String(selectedVariant.title || '') : '';
      if (activeModalVariantId) productModal.dataset.selectedVariantId = activeModalVariantId;
      else delete productModal.dataset.selectedVariantId;
      const control = activeModalIsOutsourced ? null : modalControlForVariant(activeModalVariantId);
      modalReturnFocus = trigger || document.activeElement;

      const title = activeModalProductTitle;
      const price = selectedVariant ? String(selectedVariant.price || '') : readText(card, '[data-vgm-modal-price-source]');
      const description = readText(card, '[data-vgm-modal-description-source]');
      const photo = readText(card, '[data-vgm-modal-photo-source]');
      const fallback = readText(card, '[data-vgm-modal-fallback-source]') || card.querySelector('[data-vgm-home-image]')?.currentSrc || '';
      const inquiryMailto = readText(card, '[data-vgm-modal-mailto-source]');
      const inquiryRole = readText(card, '[data-vgm-modal-role-source]') || title;
      activeModalInquiryMailto = inquiryMailto;
      activeModalInquiryRole = inquiryRole;

      productModal.classList.toggle('is-outsourced', activeModalIsOutsourced);
      if (activeModalIsOutsourced) syncOutsourcedInquiryLink(selectedVariant);

      if (productModalTitle) productModalTitle.textContent = title;
      if (productModalPrice) productModalPrice.textContent = price;
      renderModalVariantPicker(activeModalVariantId);
      if (productModalDescription) productModalDescription.textContent = description;
      if (productModalImage) {
        activeModalDefaultImage = photo || fallback;
        const selectedImage = activeModalVariants.length > 1 && selectedVariant && selectedVariant.image
          ? String(selectedVariant.image)
          : activeModalDefaultImage;
        productModalImage.dataset.fallbackSrc = fallback;
        productModalImage.dataset.fallbackApplied = 'false';
        productModalImage.alt = title;
        imageTools.then(tools => tools.cancelSwap(productModalImage));
        const preview = card.querySelector('.vgm-product-image');
        if (preview?.complete && preview.naturalWidth) productModalImage.src = preview.currentSrc;
        else productModalImage.removeAttribute('src');
        setModalImage(selectedImage || fallback, title);
      }

      const qty = control ? Math.max(0, Number(control.dataset.cartQuantity) || 0) : 0;
      if (typeof pendingBagOpen !== 'undefined' && activeModalVariantId) {
        pendingBagOpen.delete(String(activeModalVariantId));
      }
      if (activeModalIsOutsourced) {
        productModal.classList.remove('has-quantity', 'is-single', 'is-multi');
      } else {
        renderProductModalQuantity(activeModalVariantId, qty);
      }

      productModal.inert = false;
      window.VGMResponsive?.update?.();
      productModal.classList.add('is-open');
      warmCardImages(card, 6);
      if (productModalScroll) productModalScroll.scrollTop = 0;
      if (productModalDetails) productModalDetails.scrollTop = 0;
      updateModalLayout();
      productModal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('vgm-product-modal-open');

      productModalCard.classList.remove('is-from-card', 'is-expanded');
      productModalCard.style.transition = 'none';
      productModalCard.style.transform = 'none';
      productModalCard.style.opacity = '1';
      const targetRect = productModalCard.getBoundingClientRect();
      productModalCard.style.transition = '';
      productModalCard.style.transform = '';
      productModalCard.style.opacity = '';

      if (!reducedMotionQuery.matches && targetRect.width && targetRect.height) {
        setModalFlipOrigin(card);
        productModalCard.classList.add('is-from-card');
        void productModalCard.offsetWidth;
        requestAnimationFrame(() => productModalCard.classList.add('is-expanded'));
      } else {
        productModalCard.classList.add('is-expanded');
      }

      window.setTimeout(() => {
        if (productModal.classList.contains('is-open')) {

          const modalFocusTarget = productModalCloseButton || productModalCard;
          try { modalFocusTarget.focus({ preventScroll: true }); } catch (error) { modalFocusTarget.focus(); }
        }
      }, reducedMotionQuery.matches ? 0 : 180);
    };

    if (productModalVariantList) {
      productModalVariantList.addEventListener('click', (event) => {
        const pill = event.target.closest('[data-vgm-modal-variant-id]');
        if (!pill || pill.disabled) return;
        selectModalVariant(pill.dataset.vgmModalVariantId);
      });

      productModalVariantList.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        const pills = Array.from(productModalVariantList.querySelectorAll('[data-vgm-modal-variant-id]:not(:disabled)'));
        if (!pills.length) return;
        const currentIndex = Math.max(0, pills.indexOf(document.activeElement));
        const direction = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
        const next = pills[(currentIndex + direction + pills.length) % pills.length];
        event.preventDefault();
        selectModalVariant(next.dataset.vgmModalVariantId);
        next.focus();
      });
    }

    if (productModalImage) {
      productModalImage.addEventListener('error', () => {
        const fallback = productModalImage.dataset.fallbackSrc;
        if (!fallback || productModalImage.dataset.fallbackApplied === 'true') return;
        productModalImage.dataset.fallbackApplied = 'true';
        productModalImage.src = fallback;
      });
    }

    section.querySelectorAll('[data-vgm-product-open]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const card = trigger.closest('.vgm-product-card');
        openProductModal(card, trigger);
      });
    });

    if (productModalClose) productModalClose.addEventListener('click', () => closeProductModal(false));
    if (productModalCloseButton) {
      productModalCloseButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeProductModal(false);
      });
    }
    listen(document, 'keydown', (event) => {
      if (event.key === 'Escape' && productModal && productModal.classList.contains('is-open')) {
        event.preventDefault();
        closeProductModal(false);
      }
    });

    section.querySelectorAll('[data-vgm-home-image]').forEach((image) => {
      image.addEventListener('error', () => {
        const fallback = image.dataset.fallbackSrc;
        if (!fallback || image.dataset.fallbackApplied === 'true') return;
        image.dataset.fallbackApplied = 'true';
        image.classList.add('is-fallback');
        image.src = fallback;
      }, { once: true });
    });

    const replaceSectionHtml = (sectionId, html) => {
      if (!html) return;
      const current = document.getElementById(`shopify-section-${sectionId}`);
      if (!current) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = parsed.getElementById(`shopify-section-${sectionId}`);
      if (replacement) current.innerHTML = replacement.innerHTML;
    };

    const applyThemeSections = (response) => {
      if (!response || !response.sections) return;
      Object.entries(response.sections).forEach(([sectionId, html]) => replaceSectionHtml(sectionId, html));
    };

    const syncBagIconsFromHeader = () => {
      const headerBagIcon = document.querySelector(
        '#cart-icon-bubble .svg-wrapper svg, .header__icon--cart svg, a[href$="/cart"] .svg-wrapper svg, a[href$="/cart"] svg'
      );
      if (!headerBagIcon) return;
      section.querySelectorAll('[data-vgm-add-icon]').forEach((iconWrap) => {
        const clone = headerBagIcon.cloneNode(true);
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        iconWrap.replaceChildren(clone);
      });
    };
    syncBagIconsFromHeader();

    const VGM_CART_EVENT = 'vgm:cart:sync';
    const VGM_CART_OPEN_EVENT = 'vgm:cart:open';
    const VGM_VARIANT_STATE_EVENT = 'vgm:variant:state';
    const HOME_CART_SOURCE = 'vgm66-home';
    const MATCH_CART_SOURCE = 'vgm-match-reconcile';

    const cartSignature = (cart) => {
      if (!cart || !Array.isArray(cart.items)) return '';
      return [
        cart.item_count,
        cart.total_price,
        ...cart.items.map((item) => `${item.key || item.variant_id}:${item.quantity}`).sort()
      ].join('|');
    };

    let lastAppliedCartSignature = '';

    const broadcastCart = (cart, source = HOME_CART_SOURCE) => {
      if (!cart) return;
      // One canonical VGM cart event prevents the header and homepage from
      // processing the same confirmed cart multiple times.
      const detail = { cart, source };
      window.dispatchEvent(new CustomEvent(VGM_CART_EVENT, { detail }));
    };

    const fetchCart = async () => {
      const response = await fetch(`${root}cart.js`, {
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    };

    const controls = Array.from(section.querySelectorAll('[data-vgm-cart-control]'));
    const controlByVariant = new Map();
    const variantOptionById = new Map();
    const bagImageByVariant = new Map();
    const serverQty = new Map();
    const serverLineKey = new Map();
    const serverMatchQty = new Map();
    const serverMatchLineKeys = new Map();
    const desiredQty = new Map();
    const syncing = new Map();
    let hydrated = false;
    let matchDiscountUnavailable = false;

    controls.forEach((control) => {
      const variantId = String(control.dataset.variantId);
      const initialQty = Math.max(0, Number(control.dataset.cartQuantity) || 0);
      const initialKey = control.dataset.lineKey || '';
      controlByVariant.set(variantId, control);
      const bagImage = control.dataset.vgmBagImage || control.closest('.vgm-product-card')?.dataset.vgmBagImage || '';
      if (bagImage) bagImageByVariant.set(variantId, bagImage);
      serverQty.set(variantId, initialQty);
      desiredQty.set(variantId, initialQty);
      if (initialKey) serverLineKey.set(variantId, initialKey);
    });

    section.querySelectorAll('[data-vgm-variant-options][data-vgm-options-mode="cart"] option').forEach((option) => {
      const variantId = String(option.value || '');
      if (!variantId) return;
      variantOptionById.set(variantId, option);
    });

    const isMatchedLine = (item) => String(item?.properties?._vgm_match || '').toLowerCase() === 'true';

    const paidLinesForVariant = (items, variantId) => (items || []).filter((item) => (
      String(item.variant_id) === String(variantId) && !isMatchedLine(item)
    ));

    const matchedLinesForVariant = (items, variantId) => (items || []).filter((item) => {
      if (!isMatchedLine(item)) return false;
      const properties = item.properties || {};
      const sourceVariantId = properties._vgm_match_for_variant || properties._vgm_source_variant;
      return String(sourceVariantId || '') === String(variantId);
    });

    const preferredLineForVariant = (items, variantId) => {
      const paidLines = paidLinesForVariant(items, variantId);
      if (!paidLines.length) return null;
      const plain = paidLines.find((item) => {
        const props = item.properties || {};
        return Object.keys(props).length === 0 && !item.selling_plan_allocation;
      });
      return plain || paidLines[0];
    };

    const matchedLineIsFree = (item) => {
      if (!item) return false;
      return Number(item.final_line_price) === 0 || Number(item.final_price) === 0;
    };

    // Donation bag markup is rendered entirely by stafford-glass-header.
    // The homepage controller owns cart state and matched-line reconciliation only.

    const pulseQuantity = (control) => {
      const number = control && control.querySelector('[data-vgm-qty-number]');
      if (!number) return;
      number.classList.remove('is-changing');
      void number.offsetWidth;
      number.classList.add('is-changing');
      window.setTimeout(() => number.classList.remove('is-changing'), 360);
    };

    const renderControl = (variantId, quantity, { pulse = false } = {}) => {
      const control = controlByVariant.get(String(variantId));
      if (!control) return;

      const qty = Math.max(0, Number(quantity) || 0);
      const number = control.querySelector('[data-vgm-qty-number]');
      const decrease = control.querySelector('[data-vgm-decrease]');
      const plus = control.querySelector('[data-vgm-increase]');
      const productTitle = control.dataset.productTitle || i18n.itemGeneric || '';
      const available = control.dataset.variantAvailable === 'true';

      control.dataset.cartQuantity = String(qty);
      control.classList.toggle('has-quantity', qty > 0);
      control.classList.toggle('is-single', qty === 1);
      control.classList.toggle('is-multi', qty > 1);

      const dropdownOption = variantOptionById.get(String(variantId));
      if (dropdownOption) {
        dropdownOption.dataset.vgmDropdownQuantity = String(qty);
        dropdownOption.dataset.vgmDropdownAvailable = available ? 'true' : 'false';
      }

      if (number) number.textContent = String(qty || 1);
      if (decrease) {
        decrease.setAttribute(
          'aria-label',
          formatI18n(qty <= 1 ? i18n.removeFromBag : i18n.removeOneFromBag, { item: productTitle })
        );
      }
      if (plus) plus.disabled = !available;
      if (pulse && qty > 0) pulseQuantity(control);
      renderProductModalQuantity(variantId, qty, { pulse });

      window.dispatchEvent(new CustomEvent(VGM_VARIANT_STATE_EVENT, {
        detail: {
          variantId: String(variantId),
          quantity: qty,
          available,
          productTitle,
          pulse
        }
      }));
    };

    const applyServerCart = (cart, {
      resetDesired = false,
      broadcast = false,
      source = HOME_CART_SOURCE,
      force = false
    } = {}) => {
      if (lifetime.signal.aborted || !cart || !Array.isArray(cart.items)) return;
      const signature = cartSignature(cart);
      if (!force && signature && signature === lastAppliedCartSignature && !resetDesired) {
        if (broadcast) broadcastCart(cart, source);
        return;
      }

      controlByVariant.forEach((control, variantId) => {
        const line = preferredLineForVariant(cart.items, variantId);
        const matchLines = matchedLinesForVariant(cart.items, variantId);
        const qty = line ? Math.max(0, Number(line.quantity) || 0) : 0;
        const matchQty = matchLines.reduce((total, item) => total + Math.max(0, Number(item.quantity) || 0), 0);
        serverQty.set(variantId, qty);
        serverMatchQty.set(variantId, matchQty);
        serverMatchLineKeys.set(variantId, matchLines.map((item) => String(item.key || '')).filter(Boolean));
        if (line && line.key) serverLineKey.set(variantId, line.key);
        else serverLineKey.delete(variantId);

        const mutationActive = syncing.has(variantId);
        if ((!mutationActive && resetDesired) || !desiredQty.has(variantId)) {
          desiredQty.set(variantId, qty);
        }

        const shown = mutationActive
          ? Math.max(0, Number(desiredQty.get(variantId)) || 0)
          : qty;
        if (!mutationActive) desiredQty.set(variantId, qty);
        renderControl(variantId, shown);
      });

      hydrated = true;
      lastAppliedCartSignature = signature;
      if (broadcast) broadcastCart(cart, source);
      syncBagIconsFromHeader();
    };

    const postCartJson = async (path, payload) => {
      const response = await fetch(`${root}${path}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to update the donation bag');
      return data;
    };

    const removeMatchedLines = async (cart) => {
      const updates = {};
      (cart?.items || []).forEach((item) => {
        if (isMatchedLine(item) && item.key) updates[item.key] = 0;
      });
      if (Object.keys(updates).length) await postCartJson('cart/update.js', { updates });
      return fetchCart();
    };

    const requestPairQuantity = async (variantId, quantity) => {
      variantId = String(variantId);
      const target = Math.max(0, Number(quantity) || 0);
      const paidKey = serverLineKey.get(variantId) || '';
      const matchKeys = serverMatchLineKeys.get(variantId) || [];
      const pairEnabled = checkoutMatchEnabled && !matchDiscountUnavailable;
      const updates = {};
      const additions = [];
      const control = controlByVariant.get(variantId);
      const matchTitle = control?.dataset.productTitle || i18n.donationItem || '';
      const matchImage = bagImageByVariant.get(variantId) || '';

      if (paidKey) updates[paidKey] = target;
      else if (target > 0) additions.push({ id: variantId, quantity: target, ...(control?.dataset.goalLabel ? { properties: { Goal: control.dataset.goalLabel } } : {}) });

      if (pairEnabled) {
        if (matchKeys[0]) updates[matchKeys[0]] = target;
        else if (target > 0) {
          additions.push({
            id: matchVariantId,
            quantity: target,
            properties: {
              _vgm_match: 'true',
              _vgm_match_for_variant: variantId,
              _vgm_match_image: matchImage,
              _vgm_match_title: matchTitle,
              'Matched donation': matchTitle
            }
          });
        }
      } else {
        matchKeys.forEach((key) => { updates[key] = 0; });
      }

      matchKeys.slice(1).forEach((key) => { updates[key] = 0; });
      if (Object.keys(updates).length) await postCartJson('cart/update.js', { updates });
      if (additions.length) await postCartJson('cart/add.js', { items: additions });

      let cart = await fetchCart();
      if (pairEnabled && target > 0) {
        const matchLines = matchedLinesForVariant(cart.items, variantId);
        const matchQuantity = matchLines.reduce((total, item) => total + Math.max(0, Number(item.quantity) || 0), 0);
        const everyMatchIsFree = matchLines.length > 0 && matchLines.every(matchedLineIsFree);
        if (matchQuantity !== target || !everyMatchIsFree) {
          matchDiscountUnavailable = true;
          cart = await removeMatchedLines(cart);
          throw new Error('The VGM matched-donation product is unavailable or is not priced at zero. The paid item was kept and the invalid matched line was removed.');
        }
      }
      return cart;
    };

    const pendingBagOpen = new Set();

    const openDonationBag = (cart) => {
      if (readControl('--vgm65-open-bag-after-positive-change', 1) < .5) return;

      if (productModal && productModal.classList.contains('is-open')) return;

      const overlay = document.querySelector('.sgh-cart-overlay');
      if (overlay && overlay.classList.contains('is-open')) return;

      window.dispatchEvent(new CustomEvent(VGM_CART_OPEN_EVENT, {
        detail: { cart, source: HOME_CART_SOURCE }
      }));

      requestAnimationFrame(() => {
        const currentOverlay = document.querySelector('.sgh-cart-overlay');
        if (currentOverlay && currentOverlay.classList.contains('is-open')) return;
        const customOpen = document.querySelector('[data-cart-open]');
        if (customOpen && typeof customOpen.click === 'function') customOpen.click();
        else {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        }
      });
    };

    const processVariant = async (variantId) => {
      variantId = String(variantId);
      if (lifetime.signal.aborted) return;
      if (syncing.has(variantId)) return syncing.get(variantId);

      const control = controlByVariant.get(variantId);
      if (control) control.classList.add('is-syncing');

      const job = (async () => {
        try {
          while (!lifetime.signal.aborted) {
            const target = Math.max(0, Number(desiredQty.get(variantId)) || 0);
            const actual = Math.max(0, Number(serverQty.get(variantId)) || 0);
            const actualMatch = Math.max(0, Number(serverMatchQty.get(variantId)) || 0);
            const targetMatch = checkoutMatchEnabled && !matchDiscountUnavailable ? target : 0;
            if (target === actual && targetMatch === actualMatch) break;

            const positiveChange = target > actual;
            const cart = await requestPairQuantity(variantId, target);

            applyServerCart(cart, {
              resetDesired: false,
              broadcast: true,
              source: HOME_CART_SOURCE,
              force: true
            });

            if (positiveChange && pendingBagOpen.has(variantId)) {
              pendingBagOpen.delete(variantId);
              openDonationBag(cart);
            }
          }

          const confirmed = Math.max(0, Number(serverQty.get(variantId)) || 0);
          desiredQty.set(variantId, confirmed);
          renderControl(variantId, confirmed);
        } catch (error) {
          console.error('VGM cart quantity sync error:', error);
          pendingBagOpen.delete(variantId);

          try {
            const cart = await fetchCart();
            applyServerCart(cart, {
              resetDesired: true,
              broadcast: true,
              source: 'vgm66-reconcile',
              force: true
            });
          } catch (reconcileError) {
            console.warn('VGM cart reconcile failed:', reconcileError);
          }
        } finally {
          syncing.delete(variantId);
          if (control) control.classList.remove('is-syncing');

          const target = Math.max(0, Number(desiredQty.get(variantId)) || 0);
          const actual = Math.max(0, Number(serverQty.get(variantId)) || 0);
          if (target !== actual) processVariant(variantId);
        }
      })();

      syncing.set(variantId, job);
      return job;
    };

    const adjustVariant = (control, delta, { autoOpenBag = true } = {}) => {
      if (!control) return;
      const variantId = String(control.dataset.variantId);
      const available = control.dataset.variantAvailable === 'true';
      const current = desiredQty.has(variantId)
        ? Number(desiredQty.get(variantId)) || 0
        : Number(serverQty.get(variantId)) || 0;

      if (delta > 0 && !available) return;
      const next = Math.max(0, current + delta);
      if (next === current) return;

      desiredQty.set(variantId, next);
      renderControl(variantId, next, { pulse: true });

      if (delta > 0 && current === 0 && autoOpenBag && readControl('--vgm65-open-bag-after-positive-change', 1) >= .5) {
        pendingBagOpen.add(variantId);
      } else if (!autoOpenBag) {

        pendingBagOpen.delete(variantId);
      }

      processVariant(variantId);
    };

    section.querySelectorAll('[data-vgm-variant-options]').forEach((select) => {
      select.addEventListener('vgm:liquid-command', (event) => {
        const variantId = String(event.detail?.value || '');
        const variantTitle = String(event.detail?.label || '').trim();
        const mode = String(select.dataset.vgmOptionsMode || 'cart');
        const card = select.closest('.vgm-product-card');
        if (!variantId) return;

        if (card) card.dataset.vgmSelectedVariantId = variantId;

        if (mode === 'contact') {
          const roleBase = variantTitle || select.dataset.vgmOptionsProductTitle || i18n.outsourcedShortRole || '';
          const roleLabel = /outsourced employee/i.test(roleBase)
            ? roleBase
            : formatI18n(i18n.outsourcedEmployee, { role: roleBase });
          const subject = formatI18n(i18n.inquirySubject, { role: roleLabel });
          const body = formatI18n(i18n.inquiryVariantBody, { role: roleLabel });
          window.location.href = `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
          return;
        }

        const control = controlByVariant.get(variantId);
        if (!control || control.dataset.variantAvailable !== 'true') return;
        adjustVariant(control, 1, { autoOpenBag: true });
      });

      select.addEventListener('vgm:liquid-cart-action', (event) => {
        if (String(select.dataset.vgmOptionsMode || 'cart') !== 'cart') return;

        const variantId = String(event.detail?.value || '');
        const delta = Number(event.detail?.delta || 0);
        const card = select.closest('.vgm-product-card');
        if (!variantId || !Number.isFinite(delta) || delta === 0) return;

        if (card) card.dataset.vgmSelectedVariantId = variantId;

        const control = controlByVariant.get(variantId);
        if (!control) return;
        if (delta > 0 && control.dataset.variantAvailable !== 'true') return;

        /* Keep the options surface open while the quantity changes. The
           hidden proxy control remains the single cart-state authority. */
        adjustVariant(control, delta, { autoOpenBag: false });
      });
    });

    controls.forEach((control) => {
      const addForm = control.querySelector('[data-vgm-add-form]');
      const decrease = control.querySelector('[data-vgm-decrease]');
      const increase = control.querySelector('[data-vgm-increase]');

      if (addForm) {
        addForm.addEventListener('submit', (event) => {
          event.preventDefault();
          event.stopPropagation();
          adjustVariant(control, 1);
        });
      }

      if (decrease) {
        decrease.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          adjustVariant(control, -1);
        });
      }

      if (increase) {
        increase.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          adjustVariant(control, 1);
        });
      }
    });

    if (productModal) productModal.inert = true;
    const trapModalFocus = (event) => {
      if (event.key !== 'Tab' || !productModal?.classList.contains('is-open') || document.querySelector('.sgh-cart-overlay.is-open')) return;
      const items = Array.from(productModalCard.querySelectorAll('button, a[href], input, select, textarea, [tabindex]')).filter((node) => {
        return !node.disabled && node.tabIndex >= 0 && !node.closest('[inert]') && node.getClientRects().length > 0;
      });
      if (!items.length) {
        event.preventDefault();
        productModalCard.focus({ preventScroll: true });
        return;
      }
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    };
    listen(document, 'keydown', trapModalFocus);
    foundationCleanups.push(() => document.removeEventListener('keydown', trapModalFocus));

    const activeModalControl = () => activeModalVariantId
      ? controlByVariant.get(String(activeModalVariantId))
      : null;

    if (productModalAdd) {
      productModalAdd.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        adjustVariant(activeModalControl(), 1, { autoOpenBag: false });
      });
    }

    if (productModalDecrease) {
      productModalDecrease.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        adjustVariant(activeModalControl(), -1, { autoOpenBag: false });
      });
    }

    if (productModalIncrease) {
      productModalIncrease.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        adjustVariant(activeModalControl(), 1, { autoOpenBag: false });
      });
    }

    const reconcileMatchedCart = async (initialCart) => {
      let cart = initialCart;
      if (lifetime.signal.aborted || !cart || !Array.isArray(cart.items)) return cart;

      applyServerCart(cart, {
        resetDesired: syncing.size === 0,
        broadcast: false,
        source: MATCH_CART_SOURCE,
        force: true
      });

      for (const variantId of controlByVariant.keys()) {
        if (lifetime.signal.aborted) return cart;
        const paidQuantity = Math.max(0, Number(serverQty.get(variantId)) || 0);
        const matchedQuantity = Math.max(0, Number(serverMatchQty.get(variantId)) || 0);
        const matchLines = matchedLinesForVariant(cart.items, variantId);
        const expectedMatchQuantity = checkoutMatchEnabled && !matchDiscountUnavailable ? paidQuantity : 0;
        const matchIsValid = expectedMatchQuantity === 0
          ? matchedQuantity === 0
          : matchedQuantity === expectedMatchQuantity
            && matchLines.length === 1
            && matchLines.every(matchedLineIsFree);

        if (matchIsValid) continue;

        try {
          cart = await requestPairQuantity(variantId, paidQuantity);
        } catch (error) {
          console.error('VGM matched-item synchronization stopped:', error);
          cart = await fetchCart();
        }

        applyServerCart(cart, {
          resetDesired: syncing.size === 0,
          broadcast: false,
          source: MATCH_CART_SOURCE,
          force: true
        });
      }

      return cart;
    };

    let reconciliationQueue = Promise.resolve();
    let lastQueuedCartSignature = '';

    const queueCartReconciliation = (cart, source = 'theme') => {
      const signature = cartSignature(cart);
      if (!signature || signature === lastQueuedCartSignature) return;
      lastQueuedCartSignature = signature;

      reconciliationQueue = reconciliationQueue.then(async () => {
        const reconciled = await reconcileMatchedCart(cart);
        const changed = cartSignature(reconciled) !== signature;
        applyServerCart(reconciled, {
          resetDesired: true,
          broadcast: changed,
          source: changed ? MATCH_CART_SOURCE : source,
          force: true
        });
      }).catch((error) => {
        console.warn('VGM cart reconciliation skipped:', error);
      });
    };

    let hydrationPromise = null;

    const hydrateCart = ({ broadcast = true } = {}) => {
      if (lifetime.signal.aborted) return;
      if (hydrationPromise) return hydrationPromise;

      hydrationPromise = (async () => {
        try {
          const initialCart = await fetchCart();
          const cart = await reconcileMatchedCart(initialCart);
          applyServerCart(cart, {
            resetDesired: syncing.size === 0,
            broadcast,
            source: HOME_CART_SOURCE,
            force: true
          });
        } catch (error) {
          console.warn('VGM cart hydration skipped:', error);
        }
      })().finally(() => {
        hydrationPromise = null;
      });

      return hydrationPromise;
    };

    if (!lifetime.signal.aborted) hydrateCart({ broadcast: true });

    /* ==========================================================
       RECOMMENDATION CART BRIDGE

       The donation-bag recommendation engine lives in the site header, while
       this homepage controller owns VGM's matched-donation cart pairing.
       Expose one small bridge so a recommendation added from the drawer uses
       the exact same cart logic as an ADD TO BAG button on a product card.
       ========================================================== */
    const recommendationBridge = window.VGMCartBridge || {};

    recommendationBridge.addVariant = async (variantId, quantity = 1) => {
      variantId = String(variantId || '');
      const increment = Math.max(1, Number(quantity) || 1);
      const control = controlByVariant.get(variantId);
      if (!variantId || !control || control.dataset.variantAvailable !== 'true') return false;

      if (!hydrated) await hydrateCart({ broadcast: false });

      const current = desiredQty.has(variantId)
        ? Math.max(0, Number(desiredQty.get(variantId)) || 0)
        : Math.max(0, Number(serverQty.get(variantId)) || 0);

      const next = current + increment;
      desiredQty.set(variantId, next);
      pendingBagOpen.delete(variantId);
      renderControl(variantId, next, { pulse: true });
      await processVariant(variantId);
      return true;
    };

    recommendationBridge.openProduct = (productId) => {
      const card = Array.from(section.querySelectorAll('.vgm-product-card[data-product-id]')).find(
        (entry) => String(entry.dataset.productId || '') === String(productId || '')
      );
      const trigger = card?.querySelector('[data-vgm-product-open]');
      if (!trigger) return false;
      trigger.click();
      return true;
    };

    window.VGMCartBridge = recommendationBridge;
    foundationCleanups.push(() => {
      if (window.VGMCartBridge === recommendationBridge) delete window.VGMCartBridge;
      closeProductModal(true);
    });

    listen(window, VGM_CART_EVENT, (event) => {
      const detail = event.detail || {};
      if (!detail.cart || detail.source === HOME_CART_SOURCE || detail.source === 'vgm66-reconcile' || detail.source === MATCH_CART_SOURCE) return;
      queueCartReconciliation(detail.cart, detail.source || 'theme');
    });

    // Compatibility for cart mutations made by non-VGM theme code. VGM does
    // not emit cart:updated itself, so this path cannot duplicate canonical sync.
    listen(document, 'cart:updated', (event) => {
      const detail = event.detail || {};
      if (String(detail.source || '').startsWith('vgm')) return;
      if (detail.cart) queueCartReconciliation(detail.cart, detail.source || 'theme');
      else hydrateCart({ broadcast: true });
    });

    listen(window, 'pageshow', () => hydrateCart({ broadcast: true }));
    listen(window, 'focus', () => hydrateCart({ broadcast: true }));
    listen(document, 'visibilitychange', () => {
      if (document.visibilityState === 'visible') hydrateCart({ broadcast: true });
    });


  };
  const initAll = (scope = document) => {
    if (scope instanceof Element && scope.matches(sectionSelector)) init(scope);
    scope.querySelectorAll?.(sectionSelector).forEach(init);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches(sectionSelector) ? event.target : event.target.querySelector(sectionSelector);
    if (section) instances.get(section)?.();
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vgm-homepage-donation-stories"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('vgm-donation-stories')) return;
  class VgmDonationStories extends HTMLElement {
    connectedCallback() {
      if (this.lifetime) return;
      this.lifetime = new AbortController();
      this.viewport = this.querySelector('[data-story-viewport]');
      this.track = this.querySelector('[data-story-track]');
      this.previous = this.querySelector('[data-story-previous]');
      this.next = this.querySelector('[data-story-next]');
      this.touch = matchMedia('(max-width: 760px), (hover: none), (pointer: coarse), (any-pointer: coarse)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.active = null;
      this.pinned = null;
      this.hoverQuote = null;
      this.dismissed = null;
      this.cards = [];
      this.fitCache = new WeakMap();
      this.itemTexts = new WeakMap();
      this.fontRevision = 0;
      this.touchCard = null;
      this.centerPending = false;
      this.centering = false;
      this.listen(this, 'pointermove', (event) => this.pointerMove(event));
      this.listen(this, 'pointerleave', () => {
        this.hoverQuote = null;
        this.dismissed = null;
        this.setEdge(null);
        this.highlight(this.pinned || this.focusedCard());
        this.updateQuotes();
      });
      this.listen(this, 'click', (event) => {
        const button = event.target.closest('[data-story-toggle]');
        if (!button) return;
        const card = button.closest('[data-vgm-story]');
        const opening = !card.hasAttribute('data-quote-open');
        this.setEdge(null);
        this.pinned = opening ? card : null;
        this.hoverQuote = null;
        this.dismissed = opening ? null : card;
        this.highlight(opening ? card : null);
        this.updateQuotes();
      });
      this.listen(this, 'focusin', (event) => {
        if (event.target.matches('[data-story-toggle], [data-story-quote-content]')) {
          const card = event.target.closest('[data-vgm-story]');
          this.highlight(card);
          this.ensureVisible(card);
        }
      });
      this.listen(this, 'focusout', () => queueMicrotask(() => {
        if (!this.isConnected) return;
        if (!this.focusedCard() && !this.matches(':hover')) this.highlight(this.pinned);
      }));
      this.listen(this, 'keydown', (event) => {
        if (event.key === 'Escape') {
          const quoteFocused = event.target.closest('[data-story-quote]');
          const card = this.pinned || this.hoverQuote || this.active;
          this.pinned = this.hoverQuote = null;
          this.dismissed = card;
          this.highlight(null);
          this.updateQuotes();
          if (quoteFocused) card?.querySelector('[data-story-toggle]')?.focus({ preventScroll: true });
          event.stopPropagation();
        } else if (event.target === this.viewport && ['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') {
            if (this.touch.matches) this.selectTouch(this.cards[event.key === 'Home' ? 0 : this.cards.length - 1]);
            else this.viewport.scrollTo({ left: event.key === 'Home' ? 0 : this.viewport.scrollWidth, behavior: this.reduced.matches ? 'auto' : 'smooth' });
          }
          else this.advance(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      this.listen(this.previous, 'click', () => this.advance(-1));
      this.listen(this.next, 'click', () => this.advance(1));
      this.listen(this.viewport, 'scroll', () => {
        this.updateArrows();
        if (this.touch.matches) {
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.settleTouch(), 180);
        }
      }, { passive: true });
      this.listen(this.viewport, 'scrollend', () => this.settleTouch());
      this.listen(this.viewport, 'pointerdown', (event) => {
        if (event.pointerType !== 'mouse') { this.setEdge(null); this.centering = false; }
      }, { passive: true });
      this.listen(window, 'resize', () => { this.centerPending = this.touch.matches; this.schedule(); });
      this.listen(this.reduced, 'change', () => { this.setEdge(null); this.centerPending = this.touch.matches; this.schedule(); });
      this.listen(this.touch, 'change', () => {
        this.setEdge(null);
        this.hoverQuote = null;
        if (this.touch.matches) this.selectTouch(this.pinned || this.active || this.cards[0]);
        else { this.touchCard = null; this.active = this.pinned || this.focusedCard(); }
        this.updateQuotes();
      });
      this.observer = new ResizeObserver(() => this.schedule());
      this.observer.observe(this.viewport);
      this.collectCards();
      this.schedule();
      document.fonts?.ready.then(() => { if (this.isConnected) { this.fontRevision++; this.centerPending = this.touch.matches; this.schedule(); } });
      this.loadObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.loadObserver.disconnect();
        this.loadRemaining();
      }, { rootMargin: '600px' });
      this.loadObserver.observe(this);
    }
    disconnectedCallback() {
      this.lifetime?.abort();
      this.observer?.disconnect();
      this.loadObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.edgeFrame);
      clearTimeout(this.settleTimer);
      this.lifetime = null;
    }
    listen(target, type, handler, options = {}) {
      target?.addEventListener(type, handler, { ...options, signal: this.lifetime.signal });
    }
    focusedCard() { return this.contains(document.activeElement) ? document.activeElement.closest('[data-vgm-story]') : null; }
    collectCards() {
      this.cards = Array.from(this.track.querySelectorAll('[data-vgm-story]'));
      this.cards.sort((a, b) => b.dataset.postDate.localeCompare(a.dataset.postDate) || b.dataset.receivedDate.localeCompare(a.dataset.receivedDate) || a.dataset.storyId.localeCompare(b.dataset.storyId));
      this.cards.forEach((card, index) => {
        if (this.track.children[index] !== card) this.track.insertBefore(card, this.track.children[index] || null);
        card.style.setProperty('--story-layer', this.cards.length - index);
        if (!card.dataset.rotation) card.dataset.rotation = (Math.random() * 10 - 5).toFixed(2);
        card.style.setProperty('--story-tilt', `${card.dataset.rotation}deg`);
        const items = card.querySelector('[data-story-fit="items"]');
        if (items && !this.itemTexts.has(items)) this.itemTexts.set(items, items.textContent.trim());
        this.observer.observe(card.querySelector('.vgm-story-card'));
      });
      if (this.touch.matches && !this.cards.includes(this.touchCard)) {
        this.touchCard = this.cards[0] || null;
        this.active = this.touchCard;
        this.centerPending = true;
      }
      this.toggleAttribute('data-empty', !this.cards.length);
      this.querySelector('[data-story-empty]')?.toggleAttribute('hidden', !!this.cards.length);
      this.hidden = !this.cards.length && this.dataset.editor !== 'true' && Number(this.dataset.pages) <= 1;
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        if (!this.isConnected) return;
        this.fitText();
        this.layout();
        if (this.centerPending) { this.centerPending = false; this.centerTouch(); }
      });
    }
    fitText() {
      const compact = this.viewport.clientWidth <= 600;
      const fitLine = (element, base, minimum) => {
        if (!element) return;
        element.style.whiteSpace = 'nowrap';
        let size = base;
        element.style.fontSize = `${size}px`;
        while (size > minimum && element.scrollWidth > element.clientWidth + 1) element.style.fontSize = `${--size}px`;
        if (element.scrollWidth > element.clientWidth + 1) element.style.whiteSpace = 'normal';
      };
      this.cards.forEach((card) => {
        const name = card.querySelector('[data-story-fit="name"]');
        const items = card.querySelector('[data-story-fit="items"]');
        const copy = card.querySelector('.vgm-story-caption-copy');
        const fitKey = `${card.offsetWidth}:${copy.clientHeight}:${this.fontRevision}`;
        const cached = this.fitCache.get(card);
        const details = card.querySelector('.vgm-story-details');
        if (cached !== fitKey) {
          fitLine(name, compact ? 18 : 20, compact ? 14 : 16);
          if (items) {
            const original = this.itemTexts.get(items);
            items.textContent = original;
            // Use the full caption width; let wrapping respond to the fitted size.
            fitLine(items, compact ? 15 : 16, compact ? 12 : 14);
          }
          const captionText = [name, items].filter(Boolean);
          let captionScale = 1;
          const captionSizes = captionText.map((text) => parseFloat(text.style.fontSize));
          while (captionScale > .01 && (copy.scrollHeight > copy.clientHeight + 1 || captionText.some((text) => text.scrollWidth > text.clientWidth + 1))) {
            captionScale *= .94;
            captionText.forEach((text, index) => { text.style.fontSize = `${captionSizes[index] * captionScale}px`; });
          }
          const location = card.querySelector('.vgm-story-location span');
          const date = card.querySelector('.vgm-story-date');
          const pin = card.querySelector('.vgm-story-location svg');
          if (pin) { pin.style.width = '15px'; pin.style.height = '18px'; pin.style.flexBasis = '15px'; }
          let size = compact ? 12 : 13;
          details.style.fontSize = `${size}px`;
          details.style.gridTemplateColumns = date ? 'minmax(0, 1fr) auto' : 'minmax(0, 1fr)';
          if (location) location.style.whiteSpace = 'nowrap';
          if (date) date.style.whiteSpace = 'nowrap';
          while (size > 11 && ((location && location.scrollWidth > location.clientWidth + 1) || details.scrollWidth > details.clientWidth + 1)) details.style.fontSize = `${--size}px`;
          if (location && location.scrollWidth > location.clientWidth + 1) location.style.whiteSpace = 'normal';
          if (date && date.offsetWidth > details.clientWidth * .7) {
            details.style.gridTemplateColumns = location ? 'minmax(0, 1fr) minmax(0, 1fr)' : 'minmax(0, 1fr)';
            if (date.scrollWidth > date.clientWidth + 1) date.style.whiteSpace = 'normal';
          }
          let detailScale = 1;
          const detailRoom = card.querySelector('.vgm-story-media').clientHeight * .25;
          while (detailScale > .01 && (details.offsetHeight > detailRoom || details.scrollWidth > details.clientWidth + 1)) {
            detailScale *= .94;
            details.style.fontSize = `${size * detailScale}px`;
            const pin = card.querySelector('.vgm-story-location svg');
            if (pin) { pin.style.width = `${15 * detailScale}px`; pin.style.height = `${18 * detailScale}px`; pin.style.flexBasis = `${15 * detailScale}px`; }
          }
          card.style.setProperty('--story-quote-bottom', `${details.offsetHeight + 13}px`);
          this.fitCache.set(card, fitKey);
        }
        const quote = card.querySelector('[data-story-quote-content]');
        const quoteKey = quote ? `${quote.clientWidth}:${quote.clientHeight}:${this.fontRevision}` : '';
        if (quote && !quote.parentElement.hidden && quote.dataset.fitKey !== quoteKey) {
          let quoteSize = compact ? 15 : 16;
          quote.style.fontSize = `${quoteSize}px`;
          while (quoteSize > .1 && (quote.scrollHeight > quote.clientHeight || quote.scrollWidth > quote.clientWidth)) {
            quoteSize *= .94;
            quote.style.fontSize = `${quoteSize}px`;
          }
          quote.dataset.fitKey = quoteKey;
        }
      });
    }
    layout() {
      if (!this.cards.length) { this.updateArrows(); return; }
      const width = this.cards[0].offsetWidth;
      const style = getComputedStyle(this);
      const overlap = Math.min(width * .3, parseFloat(style.getPropertyValue('--story-overlap')) || 0);
      const gap = this.touch.matches ? 12 : parseFloat(style.getPropertyValue('--story-focus-gap')) || 24;
      this.step = width - overlap;
      const heights = this.cards.map((card) => card.querySelector('.vgm-story-card').offsetHeight);
      const bounds = this.cards.map((card, index) => {
        const angle = Math.abs(Number(card.dataset.rotation)) * Math.PI / 180;
        return width * Math.cos(angle) + heights[index] * Math.sin(angle);
      });
      const activeIndex = this.cards.indexOf(this.active);
      const scale = this.reduced.matches ? 1 : 1.2;
      const padding = parseFloat(getComputedStyle(this.viewport).paddingLeft) || 0;
      const touch = this.touch.matches;
      const centerOffset = touch ? Math.max(0, (this.viewport.clientWidth - padding * 2 - width) / 2) : 0;
      const positions = this.cards.map((_, index) => centerOffset + index * this.step);
      if (activeIndex >= 0) {
        const left = Math.max(0, this.viewport.scrollLeft - padding);
        const right = this.viewport.scrollLeft + this.viewport.clientWidth - padding - 12;
        const extension = width * (scale - 1) / 2;
        const naturalX = positions[activeIndex];
        if (!touch) positions[activeIndex] = Math.max(left + extension, Math.min(naturalX, right - width - extension));
        if (activeIndex > 0) {
          const target = positions[activeIndex] - extension - gap - width / 2 - bounds[activeIndex - 1] / 2;
          const shift = target - positions[activeIndex - 1];
          for (let i = 0; i < activeIndex; i++) positions[i] += shift;
        }
        if (activeIndex < positions.length - 1) {
          const target = positions[activeIndex] + width + extension + gap + (bounds[activeIndex + 1] - width) / 2;
          const shift = target - positions[activeIndex + 1];
          for (let i = activeIndex + 1; i < positions.length; i++) positions[i] += shift;
        }
      }
      this.cards.forEach((card, index) => {
        card.style.setProperty('--story-x', `${positions[index]}px`);
        card.toggleAttribute('data-highlighted', index === activeIndex);
      });
      const maxHeight = Math.max(...heights);
      const verticalRoom = Math.ceil(Math.max(maxHeight * .11 + 42, width * .055 + 32));
      this.viewport.style.paddingTop = `${verticalRoom}px`;
      this.viewport.style.paddingBottom = `${verticalRoom + 24}px`;
      const naturalEnd = (this.cards.length - 1) * this.step + width;
      const animatedEnd = Math.max(...positions.map((x, i) => x + width + (bounds[i] - width) / 2));
      const trackWidth = touch ? positions[positions.length - 1] + width + centerOffset : Math.max(naturalEnd + width * .2 + gap, animatedEnd + gap);
      this.style.setProperty('--story-track-width', `${Math.ceil(trackWidth)}px`);
      this.style.setProperty('--story-track-height', `${maxHeight}px`);
      this.style.setProperty('--story-controls-width', `${width * scale}px`);
      this.style.setProperty('--story-controls-top', `${verticalRoom + maxHeight * (1 + scale) / 2 + 12}px`);
      this.setAttribute('data-enhanced', '');
      this.updateArrows();
    }
    highlight(card) {
      if (this.touch.matches) {
        if (card && card !== this.touchCard) { this.selectTouch(card); return; }
        card = this.touchCard;
      }
      if (card === this.active) return;
      this.active = card;
      this.layout();
    }
    updateQuotes() {
      this.cards.forEach((card) => {
        const quote = card.querySelector('[data-story-quote]');
        if (!quote) return;
        const open = card !== this.dismissed && (card === this.pinned || card === this.hoverQuote);
        quote.hidden = !open;
        card.toggleAttribute('data-quote-open', open);
        const button = card.querySelector('[data-story-toggle]');
        button.setAttribute('aria-expanded', String(open));
        button.textContent = open ? button.dataset.hideLabel : button.dataset.readLabel;
        button.setAttribute('aria-label', open ? button.dataset.hideAria : button.dataset.readAria);
      });
      this.schedule();
    }
    pointerMove(event) {
      if (event.pointerType !== 'mouse' || this.touch.matches) return;
      const rect = this.viewport.getBoundingClientRect();
      const edge = event.clientX > rect.right - 82 && !this.next.hidden ? 'next' : event.clientX < rect.left + 64 && !this.previous.hidden ? 'previous' : null;
      this.setEdge(edge);
      if (edge) {
        this.pinned = this.hoverQuote = null;
        this.highlight(null);
        this.updateQuotes();
        return;
      }
      const card = event.target.closest('[data-vgm-story]');
      if (this.dismissed && card !== this.dismissed) this.dismissed = null;
      const media = event.target.closest('[data-story-media]');
      this.hoverQuote = media ? card : null;
      this.highlight(card || this.pinned || this.focusedCard());
      this.updateQuotes();
    }
    setEdge(edge) {
      if (edge === this.edge) return;
      this.edge = edge;
      if (edge) this.dataset.edge = edge;
      else delete this.dataset.edge;
      cancelAnimationFrame(this.edgeFrame);
      this.edgeFrame = 0;
      if (!edge || this.reduced.matches || this.touch.matches) return;
      let last = performance.now();
      const move = (now) => {
        if (!this.isConnected || !this.edge) return;
        const step = Math.min(40, now - last) * .22 * (this.edge === 'next' ? 1 : -1);
        last = now;
        this.viewport.scrollLeft += step;
        this.updateArrows();
        if ((this.edge === 'next' && this.next.hidden) || (this.edge === 'previous' && this.previous.hidden)) { this.setEdge(null); return; }
        this.edgeFrame = requestAnimationFrame(move);
      };
      this.edgeFrame = requestAnimationFrame(move);
    }
    updateArrows() {
      if (!this.viewport) return;
      const multiple = this.cards.length > 1;
      if (this.touch.matches) {
        const index = this.cards.indexOf(this.touchCard);
        this.previous.hidden = this.next.hidden = !multiple;
        this.previous.disabled = index <= 0;
        this.next.disabled = index < 0 || index >= this.cards.length - 1;
      } else {
        this.previous.disabled = this.next.disabled = false;
        this.previous.hidden = !multiple || this.viewport.scrollLeft <= 2;
        this.next.hidden = !multiple || this.viewport.scrollLeft >= this.viewport.scrollWidth - this.viewport.clientWidth - 2;
      }
    }
    advance(direction) {
      if (this.touch.matches) {
        const index = Math.max(0, Math.min(this.cards.length - 1, this.cards.indexOf(this.touchCard) + direction));
        this.selectTouch(this.cards[index]);
        return;
      }
      this.setEdge(null);
      this.pinned = this.hoverQuote = null;
      this.highlight(null);
      this.updateQuotes();
      this.viewport.scrollBy({ left: direction * (this.step || this.viewport.clientWidth * .8), behavior: this.reduced.matches ? 'auto' : 'smooth' });
    }
    selectTouch(card) {
      if (!card) return;
      if (card !== this.touchCard) {
        if (this.pinned !== card) this.pinned = null;
        this.hoverQuote = null;
        this.dismissed = null;
      }
      this.touchCard = this.active = card;
      this.centerPending = true;
      this.updateQuotes();
    }
    centerTouch() {
      if (!this.touch.matches || !this.touchCard) return;
      const padding = parseFloat(getComputedStyle(this.viewport).paddingLeft) || 0;
      const left = Math.max(0, parseFloat(this.touchCard.style.getPropertyValue('--story-x')) + this.touchCard.offsetWidth / 2 + padding - this.viewport.clientWidth / 2);
      if (Math.abs(left - this.viewport.scrollLeft) <= 1) { this.centering = false; return; }
      this.centering = true;
      this.viewport.scrollTo({ left, behavior: this.reduced.matches ? 'auto' : 'smooth' });
    }
    settleTouch() {
      clearTimeout(this.settleTimer);
      if (!this.isConnected || !this.touch.matches || !this.cards.length) return;
      if (this.centering) { this.centering = false; return; }
      const padding = parseFloat(getComputedStyle(this.viewport).paddingLeft) || 0;
      const center = this.viewport.scrollLeft + this.viewport.clientWidth / 2 - padding;
      const nearest = this.cards.reduce((best, card) => {
        const distance = (item) => Math.abs(parseFloat(item.style.getPropertyValue('--story-x')) + item.offsetWidth / 2 - center);
        return distance(card) < distance(best) ? card : best;
      });
      this.selectTouch(nearest);
    }
    ensureVisible(card) {
      if (this.touch.matches) { this.centerPending = true; this.schedule(); return; }
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const rect = card.getBoundingClientRect();
        const view = this.viewport.getBoundingClientRect();
        const shift = rect.left < view.left + 24 ? rect.left - view.left - 24 : rect.right > view.right - 24 ? rect.right - view.right + 24 : 0;
        if (shift) this.viewport.scrollBy({ left: shift, behavior: this.reduced.matches ? 'auto' : 'smooth' });
      });
    }
    async loadRemaining() {
      const pages = Number(this.dataset.pages) || 1;
      const current = Number(this.dataset.currentPage) || 1;
      if (pages <= 1) return;
      this.setAttribute('aria-busy', 'true');
      const seen = new Set(this.cards.map((card) => card.dataset.storyId));
      try {
        for (let page = 1; page <= pages; page++) {
          if (page === current) continue;
          const url = new URL(location.href);
          url.searchParams.delete('sections');
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set(this.dataset.pageParam || 'page', String(page));
          const response = await fetch(url, { signal: this.lifetime.signal });
          if (!response.ok) throw new Error('Section request failed');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = document.getElementById(this.id);
          if (!section) throw new Error('Story section missing');
          section.querySelectorAll('[data-vgm-story]').forEach((card) => {
            if (!seen.has(card.dataset.storyId)) { seen.add(card.dataset.storyId); this.track.append(card); }
          });
        }
        this.collectCards();
        this.hidden = !this.cards.length && this.dataset.editor !== 'true';
        this.schedule();
      } catch (error) {
        this.collectCards();
        this.schedule();
        if (error.name !== 'AbortError' && this.isConnected) {
          this.setAttribute('data-load-failed', '');
          this.querySelector('[data-story-status]').textContent = this.dataset.loadError;
        }
      } finally { this.removeAttribute('aria-busy'); }
    }
  }
  customElements.define('vgm-donation-stories', VgmDonationStories);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vgm-homepage-giving-goes"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('vgm-giving-goes')) {
  import('@theme/vgm-images').then(images => {
    class VgmGivingGoes extends HTMLElement {
      connectedCallback() { this.initialize(); }
      disconnectedCallback() { this.cleanup(); }
      initialize() {
        if (this.lifetime) return;
        this.steps = [...this.querySelectorAll('[data-giving-step]')];
        if (!this.steps.length) return;
        this.refs = Object.fromEntries(['stage', 'stageInner', 'media', 'layout', 'chapters', 'wheel'].map(name => [name, this.querySelector(`[ref="${name}"]`)]));
        this.shell = this.querySelector('.vgm-giving__shell');
        this.intro = this.querySelector('.vgm-giving__intro');
        this.siteHeader = document.querySelector('[data-sgh-header]');
        this.viewport = this.querySelector('[data-giving-wheel-viewport]');
        this.navigator = this.refs.wheel;
        this.figures = [...this.querySelectorAll('[data-giving-image]')];
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.lifetime = new AbortController();
        const signal = this.lifetime.signal;
        this.activeIndex = -1;
        this.segments = [];
        this.setAttribute('data-enhanced', '');
        this.viewport.removeAttribute('tabindex');
        this.querySelectorAll('[data-giving-wheel-control]').forEach(control => { control.hidden = false; });
        this.addEventListener('click', event => {
          if (event.target instanceof Element && event.target.closest('[data-giving-summary]')) event.preventDefault();
        }, { signal });
        document.addEventListener('scroll', () => this.scheduleScroll(), { capture: true, passive: true, signal });
        window.addEventListener('resize', () => this.scheduleLayout(), { passive: true, signal });
        this.motionQuery.addEventListener('change', () => {
          if (this.motionQuery.matches) this.imageAnimation?.finish();
          this.scheduleLayout();
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
        this.resizeObserver.observe(this.shell);
        for (const step of this.steps) this.resizeObserver.observe(step.querySelector('.vgm-giving__body'));
        this.setActive(0, false);
        this.scheduleLayout();
        const lifetime = this.lifetime;
        document.fonts.ready.then(() => { if (this.lifetime === lifetime) this.scheduleLayout(); });
        this.imageObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.imageObserver.disconnect();
          this.warmImages();
        }, { rootMargin: '600px' });
        this.imageObserver.observe(this);
      }
      cleanup() {
        this.lifetime?.abort();
        this.lifetime = null;
        this.resizeObserver?.disconnect();
        this.imageObserver?.disconnect();
        this.imageRevision = (this.imageRevision || 0) + 1;
        this.imageAnimation?.cancel();
        this.imageExitAnimation?.cancel();
        cancelAnimationFrame(this.layoutFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.layoutFrame = this.scrollFrame = 0;
        this.removeAttribute('data-enhanced');
        this.removeAttribute('data-page-scroll');
        this.removeAttribute('data-static-scroll');
        this.viewport?.removeAttribute('tabindex');
        this.querySelectorAll('[data-giving-wheel-control]').forEach(control => { control.hidden = true; });
        for (const step of this.steps || []) {
          step.closest('li').inert = false;
          step.closest('li').removeAttribute('aria-hidden');
          step.querySelector('summary').removeAttribute('tabindex');
          step.querySelector('.vgm-giving__panel').inert = false;
        }
      }
      setActive(index, animate, force = false) {
        if (!this.steps[index] || (index === this.activeIndex && !force)) return;
        this.activeIndex = index;
        for (const [i, step] of this.steps.entries()) {
          const active = i === index;
          const open = true;
          step.open = open;
          step.toggleAttribute('data-active', active);
          step.dataset.expanded = String(open);
          const summary = step.querySelector('summary');
          summary.setAttribute('aria-expanded', String(open));
          summary.tabIndex = -1;
          if (active) summary.setAttribute('aria-current', 'step');
          else summary.removeAttribute('aria-current');
          const panel = step.querySelector('.vgm-giving__panel');
          panel.inert = !open;
          panel.style.removeProperty('max-height');
          panel.removeAttribute('tabindex');
          const chapter = step.closest('li');
          chapter.inert = !this.staticFlow && Math.abs(i - index) > 1;
          if (chapter.inert) chapter.setAttribute('aria-hidden', 'true');
          else chapter.removeAttribute('aria-hidden');
        }
        this.navigator.querySelector('[data-giving-position]').textContent = this.navigator.dataset.positionTemplate.replace('__CURRENT__', String(index + 1));
        this.dataset.currentStep = String(index + 1);
        if (!this.staticFlow) this.showFigure(index, animate);
      }
      scheduleLayout() {
        if (this.layoutFrame || !this.lifetime) return;
        this.layoutFrame = requestAnimationFrame(() => { this.layoutFrame = 0; this.measureLayout(); });
      }
      headerClearance() {
        const base = this.baseClearance || 118;
        return window.innerWidth > 850
          ? Math.max(base, Math.ceil(this.siteHeader?.getBoundingClientRect().bottom || 0) + 28)
          : base;
      }
      measureLayout() {
        if (!this.lifetime) return;
        const style = getComputedStyle(this);
        this.baseClearance = Math.max(16, parseFloat(style.getPropertyValue('--vgm-layout-anchor-clearance')) || 118);
        this.clearance = this.headerClearance();
        this.padTop = parseFloat(style.getPropertyValue('--vgm-giving-top')) || 0;
        this.holdDistance = Math.max(200, parseFloat(style.getPropertyValue('--vgm-giving-scroll-step-distance')) || 420);
        const maxHeight = parseFloat(style.getPropertyValue('--vgm-giving-wheel-max-height')) || 680;
        this.style.setProperty('--vgm-giving-clearance', `${this.clearance}px`);
        const introHeight = this.intro.getBoundingClientRect().height + (parseFloat(getComputedStyle(this.intro).marginBottom) || 0);
        const available = window.innerHeight - this.clearance - 24 - introHeight;
        const stacked = window.matchMedia('(max-width: 850px)').matches;
        const hasStage = this.refs.stage && !this.refs.stage.hidden;
        const imageMax = parseFloat(style.getPropertyValue('--vgm-giving-scroll-mobile-image-height')) || 160;
        const imageHeight = hasStage && stacked ? Math.min(this.shell.clientWidth * .42, imageMax) : 0;
        const gap = stacked && hasStage ? (parseFloat(getComputedStyle(this.refs.layout).rowGap) || 24) : 0;
        const wheelHeight = Math.min(maxHeight, Math.floor(available - imageHeight - gap));
        const staticFlow = wheelHeight < 260;
        const modeChanged = this.staticFlow !== staticFlow;
        this.staticFlow = staticFlow;
        this.toggleAttribute('data-page-scroll', !staticFlow);
        this.toggleAttribute('data-static-scroll', staticFlow);
        if (modeChanged) this.setActive(Math.max(0, this.activeIndex), false, true);
        if (staticFlow) {
          this.style.removeProperty('--vgm-giving-scroll-distance');
          this.followPageScroll();
          return;
        }
        this.style.setProperty('--vgm-giving-wheel-height', `${wheelHeight}px`);
        const imageBottomGap = Math.max(32, Math.min(56, window.innerHeight * .05));
        const imageAvailable = window.innerHeight - this.clearance - introHeight - imageBottomGap;
        const desktopImageSize = hasStage ? Math.min(imageAvailable, this.refs.stage.clientWidth) : wheelHeight;
        this.style.setProperty('--vgm-giving-image-height', `${Math.floor(stacked ? imageHeight : desktopImageSize)}px`);
        this.peek = Math.min(parseFloat(style.getPropertyValue('--vgm-giving-wheel-peek')) || 76, this.viewport.clientHeight * .16);
        const readingHeight = Math.max(100, this.viewport.clientHeight - this.peek * 2);
        let cursor = 0;
        this.readingHeight = readingHeight;
        this.chapterGap = Math.max(48, this.holdDistance * .18);
        this.segments = this.steps.map(step => {
          step.open = true;
          const height = step.offsetHeight;
          const segment = { top: cursor, center: cursor + height / 2, height, overflow: Math.max(0, height - readingHeight) };
          cursor += height + this.chapterGap;
          return segment;
        });
        this.cameraStart = this.segments[0].center - this.segments[0].overflow / 2;
        const last = this.segments[this.segments.length - 1];
        this.cameraEnd = last.center + last.overflow / 2;
        this.totalDistance = Math.max(1, this.cameraEnd - this.cameraStart);
        this.style.setProperty('--vgm-giving-scroll-distance', `${Math.round(this.totalDistance)}px`);
        this.style.setProperty('--vgm-giving-scene-height', `${Math.ceil(this.shell.getBoundingClientRect().height)}px`);
        this.positionToken = null;
        this.followPageScroll();
      }
      scheduleScroll() {
        if (this.scrollFrame || !this.lifetime) return;
        this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = 0; this.followPageScroll(); });
      }
      followPageScroll() {
        if (!this.lifetime) return;
        if (window.innerWidth > 850 && Math.abs(this.headerClearance() - this.clearance) > 1) {
          this.scheduleLayout();
          return;
        }
        if (this.staticFlow) {
          let index = 0;
          for (const [i, step] of this.steps.entries()) if (step.querySelector('summary').getBoundingClientRect().top <= this.clearance + 80) index = i;
          this.setActive(index, false);
          return;
        }
        if (!this.segments.length) return;
        const progress = Math.max(0, Math.min(this.totalDistance, this.clearance - this.getBoundingClientRect().top - this.padTop));
        const camera = this.cameraStart + progress;
        let index = 0;
        let nearest = Infinity;
        this.segments.forEach((segment, i) => {
          const distance = Math.abs(segment.center - camera);
          if (distance < nearest) { nearest = distance; index = i; }
        });
        this.scrollDirection = progress >= (this.lastProgress ?? progress) ? 1 : -1;
        this.lastProgress = progress;
        this.setActive(index, true);
        this.dataset.scrollProgress = String(Math.round(progress / this.totalDistance * 100));
        this.positionChapters(camera);
      }
      positionChapters(camera) {
        const token = `${this.activeIndex}:${camera.toFixed(2)}`;
        if (this.positionToken === token) return;
        this.positionToken = token;
        const viewportHeight = this.viewport.clientHeight;
        for (const [index, step] of this.steps.entries()) {
          const segment = this.segments[index];
          const y = segment.center - camera;
          const focusDistance = Math.max(0, Math.abs(y) - segment.overflow / 2);
          const distance = Math.min(1, focusDistance / (viewportHeight * .7));
          const eased = distance * distance * (3 - 2 * distance);
          const chapter = step.closest('li');
          chapter.style.setProperty('--wheel-y', `${y.toFixed(2)}px`);
          chapter.style.setProperty('--wheel-scale', this.motionQuery.matches ? '1' : String(1 - eased * .09));
          chapter.style.setProperty('--wheel-tilt', `${this.motionQuery.matches ? 0 : Math.max(-14, Math.min(14, -y / viewportHeight * 18))}deg`);
          chapter.style.setProperty('--wheel-opacity', String(1 - eased * .76));
          chapter.style.setProperty('--wheel-blur', `${this.motionQuery.matches ? 0 : eased * 1.6}px`);
          chapter.dataset.wheelDistance = String(Math.abs(index - this.activeIndex));
          chapter.removeAttribute('data-long-step');
          chapter.style.zIndex = index === this.activeIndex ? '2' : '1';
        }
        const active = this.segments[this.activeIndex];
        const image = this.currentFigure?.querySelector('img');
        if (image) image.style.transform = this.motionQuery.matches ? 'none' : `translateY(${Math.max(-10, Math.min(10, (active.center - camera) / viewportHeight * 16)).toFixed(2)}px) scale(1.045)`;
      }
      async prepareFigure(index) {
        const lifetime = this.lifetime;
        const image = this.figures.find(figure => Number(figure.dataset.givingImage) === index)?.querySelector('img');
        if (!image) return null;
        const width = Math.max(1, images.renderWidth(image, this.refs.media));
        image.sizes = `${width}px`;
        const currentWidth = image.currentSrc ? Number(new URL(image.currentSrc, location.href).searchParams.get('width')) : 0;
        if (image.complete && image.naturalWidth && currentWidth >= Math.min(1800, width * Math.min(window.devicePixelRatio || 1, 2))) {
          await image.decode?.().catch(() => {});
          return image;
        }
        const prepared = await images.prepareImage(image.src, { srcset: image.srcset, sizes: image.sizes });
        if (lifetime?.signal.aborted || this.lifetime !== lifetime || !this.isConnected) return null;
        image.loading = 'eager';
        await image.decode?.().catch(() => {});
        return prepared;
      }

      async warmImages() {
        const lifetime = this.lifetime;
        const indices = [this.activeIndex, ...this.steps.keys()].filter((value, index, list) => list.indexOf(value) === index);
        for (const index of indices) {
          if (lifetime?.signal.aborted || this.lifetime !== lifetime || !this.isConnected) return;
          if (index !== this.activeIndex && images.limitedConnection()) break;
          try { await this.prepareFigure(index); } catch {}
        }
      }

      async showFigure(index, animate) {
        const revision = this.imageRevision = (this.imageRevision || 0) + 1;
        const figure = this.figures.find(item => Number(item.dataset.givingImage) === index && item.querySelector('img'));
        this.imageAnimation?.cancel();
        this.imageExitAnimation?.cancel();
        for (const item of this.figures) {
          item.removeAttribute('data-image-entering');
          item.removeAttribute('aria-hidden');
          if (this.currentFigure) item.hidden = item !== this.currentFigure;
        }
        if (!figure) {
          this.figures.forEach(item => { item.hidden = true; });
          if (this.refs.stage) this.refs.stage.hidden = true;
          return;
        }
        if (this.refs.stage) this.refs.stage.hidden = false;
        if (!animate) {
          this.currentFigure = figure;
          this.figures.forEach(item => { item.hidden = item !== figure; });
          return;
        }
        this.dataset.imageState = 'loading';
        const started = performance.now();
        try { await this.prepareFigure(index); } catch {
          if (revision === this.imageRevision) this.dataset.imageState = 'error';
          return;
        }
        if (revision !== this.imageRevision || !this.lifetime || this.lifetime.signal.aborted) return;
        const previous = this.figures.find(item => !item.hidden && item !== figure);
        this.figures.forEach(item => { item.hidden = item !== previous && item !== figure; });
        figure.hidden = false;
        this.currentFigure = figure;
        this.dataset.imageState = 'ready';
        this.dataset.imageWaitMs = String(Math.round(performance.now() - started));
        if (previous && !this.motionQuery.matches) {
          previous.setAttribute('aria-hidden', 'true');
          figure.setAttribute('data-image-entering', '');
          const direction = this.scrollDirection || 1;
          const animation = this.imageAnimation = figure.animate([
            { transform: `translateY(${direction * 12}%) scale(1.08)`, clipPath: direction > 0 ? 'inset(100% 0 0 0 round 20px)' : 'inset(0 0 100% 0 round 20px)' },
            { transform: 'translateY(0) scale(1)', clipPath: 'inset(0 0 0 0 round 20px)' }
          ], { duration: 900, easing: 'cubic-bezier(.22,1,.36,1)' });
          this.imageExitAnimation = previous.animate([
            { transform: 'translateY(0) scale(1)' },
            { transform: `translateY(${-direction * 8}%) scale(.96)` }
          ], { duration: 900, easing: 'cubic-bezier(.22,1,.36,1)' });
          animation.finished.catch(() => {}).then(() => {
            if (revision !== this.imageRevision) return;
            previous.hidden = true;
            previous.removeAttribute('aria-hidden');
            figure.removeAttribute('data-image-entering');
          });
        } else if (previous) previous.hidden = true;
        this.scheduleLayout();
      }



    }
    if (!customElements.get('vgm-giving-goes')) customElements.define('vgm-giving-goes', VgmGivingGoes);
  }).catch(error => console.error('Unable to initialize the giving process section.', error));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vgm-homepage-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sectionSelector = '.vgm-section-hero';
  const instances = new WeakMap();
  const init = (section) => {
    if (!section || section.dataset.vgmInitialized === 'true') return;
    section.dataset.vgmInitialized = 'true';
    const lifetime = new AbortController();
    const foundationCleanups = [];
    let refreshHeroCurve = () => {};
    const listen = (target, type, handler, options = {}) => {
      if (!target) return;
      target.addEventListener(type, handler, { ...options, signal: lifetime.signal });
    };
    const dispose = () => {
      lifetime.abort();
      foundationCleanups.splice(0).forEach((cleanup) => cleanup());
      delete section.dataset.vgmInitialized;
      instances.delete(section);
    };
    instances.set(section, dispose);
    const vgmHome = section.querySelector('.vgm-home');
    const styleControls = vgmHome ? getComputedStyle(vgmHome) : null;
    const readControl = (name, fallback) => {
      const value = parseFloat(styleControls?.getPropertyValue(name));
      return Number.isFinite(value) ? value : fallback;
    };
    const heroTitlePanel = section.querySelector('.vgm-hero');
    const heroTitle = heroTitlePanel?.querySelector('.vgm-hero-title');
    let heroTitleFrame = 0;
    const fitHeroTitle = () => {
      heroTitleFrame = 0;
      if (!heroTitle?.isConnected || window.matchMedia('(max-width: 1050px)').matches) return;
      heroTitle.style.removeProperty('font-size');
      heroTitle.style.removeProperty('white-space');
      // The desktop word composition has its own scale and deliberate line breaks.
      if (heroTitle.classList.contains('vgm-hero-title--pearl') && window.matchMedia('(min-width: 1051px)').matches) return;
      if (window.matchMedia('(max-width: 1050px)').matches) return;

      const availableWidth = heroTitle.clientWidth;
      if (!availableWidth) return;
      const baseSize = parseFloat(getComputedStyle(heroTitle).fontSize) || 54;
      heroTitle.style.whiteSpace = 'nowrap';
      const naturalWidth = heroTitle.scrollWidth;
      if (naturalWidth <= availableWidth + 1) return;

      const minimumSize = 38;
      let fittedSize = Math.max(minimumSize, Math.floor(baseSize * availableWidth / naturalWidth * 0.98));
      heroTitle.style.fontSize = `${fittedSize}px`;
      while (heroTitle.scrollWidth > heroTitle.clientWidth + 1 && fittedSize > minimumSize) {
        fittedSize -= 1;
        heroTitle.style.fontSize = `${fittedSize}px`;
      }
      if (heroTitle.scrollWidth > heroTitle.clientWidth + 1) {
        heroTitle.style.whiteSpace = 'normal';
      }
    };
    const scheduleHeroTitleFit = () => {
      if (!heroTitle || heroTitleFrame) return;
      heroTitleFrame = requestAnimationFrame(fitHeroTitle);
    };
    if (heroTitle) {
      const heroTitleObserver = typeof ResizeObserver === 'function'
        ? new ResizeObserver(scheduleHeroTitleFit)
        : null;
      heroTitleObserver?.observe(heroTitlePanel);
      listen(window, 'resize', scheduleHeroTitleFit, { passive: true });
      document.fonts?.ready.then(scheduleHeroTitleFit).catch(() => {});
      scheduleHeroTitleFit();
      foundationCleanups.push(() => {
        heroTitleObserver?.disconnect();
        cancelAnimationFrame(heroTitleFrame);
        window.removeEventListener('resize', scheduleHeroTitleFit);
      });
    }

    const localization = section.querySelector('.vgm-localization-controls');
    let refreshHeroLocalization = () => {};
    const headerShell = document.querySelector('[data-sgh-header]');
    const pageWrapper = section.querySelector('.section-virtual-giving-home');
    const pageShell = section.querySelector('.vgm-shell');
    if (localization && headerShell && pageShell) {
      let layoutFrame = 0;
      const updateLocalization = () => {
        layoutFrame = 0;
        if (!section.isConnected) return;
        if (pageWrapper.dataset.vgmMorphActive === 'true') return;
        const headerRect = headerShell.getBoundingClientRect();
        const pageRect = pageShell.getBoundingClientRect();
        const compact = window.matchMedia('(max-width: 760px)').matches;
        const controlsWidth = Array.from(localization.children).reduce((total, child) => total + child.getBoundingClientRect().width, 0)
          + Math.max(0, localization.children.length - 1) * (parseFloat(getComputedStyle(localization).columnGap) || 0);
        const clearance = readControl('--vgm-layout-localization-gap', 18);
        const stacked = compact || pageRect.right - headerRect.right < controlsWidth + clearance;
        pageWrapper.toggleAttribute('data-vgm-localization-stacked', stacked);
        const pageTop = Math.max(0, pageWrapper.getBoundingClientRect().top);
        pageWrapper.style.setProperty('--vgm-header-clearance', `${Math.ceil(headerRect.bottom + clearance - pageTop)}px`);
      };
      refreshHeroLocalization = updateLocalization;
      const scheduleLocalization = () => { if (!layoutFrame) layoutFrame = requestAnimationFrame(updateLocalization); };
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleLocalization) : null;
      observer?.observe(headerShell);
      observer?.observe(pageShell);
      listen(window, 'resize', scheduleLocalization, { passive: true });
      document.fonts?.ready.then(scheduleLocalization);
      scheduleLocalization();
      foundationCleanups.push(() => {
        observer?.disconnect();
        cancelAnimationFrame(layoutFrame);
        window.removeEventListener('resize', scheduleLocalization);
      });
    }

    const morphRoot = section.querySelector('[data-vgm-morph-module]');
    if (morphRoot) {
      import(morphRoot.dataset.vgmMorphModule).then(({ mountHeroMorph }) => {
        if (lifetime.signal.aborted) return;
        foundationCleanups.push(mountHeroMorph(section, {
          refreshLocalization: refreshHeroLocalization,
          refreshCompactLayout: () => { for (let i = 0; i < 4; i += 1) refreshHeroCurve(); }
        }));
      }).catch((error) => { console.error('VGM hero animation could not load.', error); morphRoot.dataset.vgmHeroPhase = 'detail'; });
    }

    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const bindReliableSectionLink = (selector, targetSelector) => {
      const trigger = section.querySelector(selector);
      if (!trigger) return;


      trigger.addEventListener('click', (event) => {

        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const target = document.querySelector(targetSelector);
        if (!target) return;
        event.preventDefault();
        const configuredOffset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
        const headerBottom = document.querySelector('[data-sgh-header]')?.getBoundingClientRect().bottom || 0;
        const offset = Math.max(0, configuredOffset, headerBottom + readControl('--vgm-layout-localization-gap', 18));
        target.style.scrollMarginTop = `${offset}px`;

        try {
          target.scrollIntoView({
            behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
            block: 'start',
            inline: 'nearest'
          });
        } catch (error) {

          const y = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
          window.scrollTo(0, y);
        }
      }, { passive: false, capture: true });
    };

    bindReliableSectionLink('.vgm-btn-donate', '#vgm-donate');


    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const heroPanel = section.querySelector('.vgm-hero');
    const aboutPanel = section.querySelector('.vgm-about');
    const aboutBody = aboutPanel?.querySelector('.vgm-about-copy p');
    if (aboutBody) {
      let curveFrame = 0;
      const fitAboutCurve = () => {
        curveFrame = 0;
        if (!aboutBody.isConnected || !window.matchMedia('(max-width: 1050px)').matches) return;
        if (section.querySelector('[data-vgm-morph-active]')) return;
        const panelBox = aboutPanel.getBoundingClientRect();
        const bodyBox = aboutBody.getBoundingClientRect();
        const scale = panelBox.width / aboutPanel.offsetWidth;
        if (!scale || !aboutBody.offsetHeight) return;
        const panelStyle = getComputedStyle(aboutPanel);
        const radius = Math.min(parseFloat(panelStyle.borderBottomRightRadius) || 0, aboutPanel.offsetHeight);
        const clearance = Math.max(12, parseFloat(panelStyle.paddingRight) || 0);
        const innerRadius = Math.max(0, radius - clearance);
        const width = Math.min(radius, Math.max(0, aboutBody.offsetWidth - 20));
        const height = aboutBody.offsetHeight;
        const bodyTop = (bodyBox.top - panelBox.top) / scale;
        const bodyRight = (bodyBox.right - panelBox.left) / scale;
        const centerY = aboutPanel.offsetHeight - radius;
        const points = [`${width}px 0px`, `${width}px ${height}px`];
        for (let i = 32; i >= 0; i -= 1) {
          const y = height * i / 32;
          const dy = Math.max(0, bodyTop + y - centerY);
          const edge = aboutPanel.offsetWidth - radius + Math.sqrt(Math.max(0, innerRadius ** 2 - dy ** 2));
          const exclusion = Math.min(width, Math.max(0, bodyRight - edge));
          points.push(`${(width - exclusion).toFixed(2)}px ${y.toFixed(2)}px`);
        }
        aboutBody.style.setProperty('--vgm-about-curve-width', `${width}px`);
        aboutBody.style.setProperty('--vgm-about-body-height', `${height}px`);
        aboutBody.style.setProperty('--vgm-about-curve-shape', `polygon(${points.join(',')})`);
      };
      refreshHeroCurve = fitAboutCurve;
      const scheduleAboutCurve = () => {
        if (!curveFrame) curveFrame = requestAnimationFrame(fitAboutCurve);
      };
      if ('ResizeObserver' in window) {
        const curveObserver = new ResizeObserver(scheduleAboutCurve);
        curveObserver.observe(aboutPanel);
        curveObserver.observe(aboutBody);
        foundationCleanups.push(() => curveObserver.disconnect());
      }
      listen(window, 'resize', scheduleAboutCurve, { passive: true });
      document.fonts?.ready.then(() => { if (!lifetime.signal.aborted) scheduleAboutCurve(); });
      scheduleAboutCurve();
      foundationCleanups.push(() => cancelAnimationFrame(curveFrame));
    }
    const childWrap = section.querySelector('.vgm-child');
    if (childWrap) {
      const subjectStage = section.querySelector('.vgm-top');
      let subjectFitFrame = 0;
      const rootMorphActive = () => section.querySelector('[data-vgm-morph-active]');
      const fitSubject = () => {
        subjectFitFrame = 0;
        if (!childWrap.isConnected || !subjectStage) return;
        if (rootMorphActive()) return;
        if (!window.matchMedia('(max-width: 1050px)').matches) return;
        const availableHeight = subjectStage.clientHeight - childWrap.offsetTop - 16;
        section.parentElement.style.setProperty('--vgm-subject-fit-width', `${Math.max(0, availableHeight) * 394 / 790}px`);
      };
      const scheduleSubjectFit = () => {
        if (!subjectFitFrame) subjectFitFrame = requestAnimationFrame(fitSubject);
      };
      if ('ResizeObserver' in window && subjectStage) {
        const subjectFitObserver = new ResizeObserver(scheduleSubjectFit);
        subjectFitObserver.observe(subjectStage);
        foundationCleanups.push(() => subjectFitObserver.disconnect());
      }
      listen(window, 'resize', scheduleSubjectFit, { passive: true });
      scheduleSubjectFit();
      foundationCleanups.push(() => cancelAnimationFrame(subjectFitFrame));
    }

    const heroParallax = section.querySelector('.vgm-hero-bg');
    const aboutParallax = section.querySelector('.vgm-about-bg');
    const childParallax = section.querySelector('.vgm-child img');

    if (
      !motionQuery.matches && !section.querySelector('[data-vgm-hero-phase="intro"]') &&
      vgmHome &&
      heroPanel && aboutPanel && childWrap &&
      heroParallax && aboutParallax && childParallax
    ) {
      const layerConfig = [
        {
          name: 'hero',
          anchor: heroPanel,
          element: heroParallax,
          cssVar: '--vgm64-parallax-hero-y',
          triggerTop: readControl('--vgm64-parallax-hero-trigger-top', 135),
          speed: readControl('--vgm64-parallax-hero-speed', 0.020),
          max: readControl('--vgm64-parallax-hero-max', 14),
          lag: readControl('--vgm64-parallax-hero-lag', 0.070),
          activationScroll: 0,
          current: 0
        },
        {
          name: 'about',
          anchor: aboutPanel,
          element: aboutParallax,
          cssVar: '--vgm64-parallax-about-y',
          triggerTop: readControl('--vgm64-parallax-about-trigger-top', 150),
          speed: readControl('--vgm64-parallax-about-speed', 0.034),
          max: readControl('--vgm64-parallax-about-max', 20),
          lag: readControl('--vgm64-parallax-about-lag', 0.080),
          activationScroll: 0,
          current: 0
        },
        {
          name: 'child',
          anchor: childWrap,
          element: childParallax,
          cssVar: '--vgm64-parallax-child-y',
          triggerTop: readControl('--vgm64-parallax-child-trigger-top', 190),
          speed: readControl('--vgm64-parallax-child-speed', 0.052),
          max: readControl('--vgm64-parallax-child-max', 26),
          lag: readControl('--vgm64-parallax-child-lag', 0.100),
          activationScroll: 0,
          current: 0
        }
      ];

      const getDeviceMultiplier = () => motionQuery.matches ? 0 : readControl('--vgm-layout-motion-multiplier', 1);

      let deviceMultiplier = getDeviceMultiplier();
      let geometryDirty = true;
      let ticking = false;
      let animationFrame = 0;

      const refreshParallaxGeometry = () => {

        layerConfig.forEach((layer) => {
          const documentTop = layer.anchor.getBoundingClientRect().top + window.scrollY;
          layer.activationScroll = Math.max(0, documentTop - layer.triggerTop);
        });
        deviceMultiplier = getDeviceMultiplier();
        geometryDirty = false;
      };

      const updateParallax = () => {
        if (geometryDirty) refreshParallaxGeometry();

        let stillMoving = false;
        const pageY = window.scrollY;

        layerConfig.forEach((layer) => {
          const distanceAfterTrigger = Math.max(0, pageY - layer.activationScroll);
          const maxTravel = Math.max(0, layer.max * deviceMultiplier);
          const target = -Math.min(maxTravel, distanceAfterTrigger * layer.speed * deviceMultiplier);
          const lag = Math.min(1, Math.max(0.01, layer.lag));

          layer.current += (target - layer.current) * lag;

          if (Math.abs(target - layer.current) > 0.025) stillMoving = true;
          layer.element.style.setProperty(layer.cssVar, `${layer.current.toFixed(2)}px`);
        });

        if (stillMoving) {
          animationFrame = requestAnimationFrame(updateParallax);
        } else {
          ticking = false;
        }
      };

      const requestParallaxUpdate = () => {
        if (ticking) return;
        ticking = true;
        cancelAnimationFrame(animationFrame);
        animationFrame = requestAnimationFrame(updateParallax);
      };

      const refreshAndRequest = () => {
        geometryDirty = true;
        requestParallaxUpdate();
      };

      listen(window, 'scroll', requestParallaxUpdate, { passive: true });
      listen(window, 'resize', refreshAndRequest, { passive: true });

      if ('ResizeObserver' in window) {
        const parallaxResizeObserver = new ResizeObserver(refreshAndRequest);
        parallaxResizeObserver.observe(heroPanel);
        parallaxResizeObserver.observe(aboutPanel);
        parallaxResizeObserver.observe(childWrap);
        foundationCleanups.push(() => parallaxResizeObserver.disconnect());
      }

      foundationCleanups.push(() => cancelAnimationFrame(animationFrame));
      refreshAndRequest();
    }

  };
  const initAll = (scope = document) => {
    if (scope instanceof Element && scope.matches(sectionSelector)) init(scope);
    scope.querySelectorAll?.(sectionSelector).forEach(init);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches(sectionSelector) ? event.target : event.target.querySelector(sectionSelector);
    if (section) instances.get(section)?.();
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vgm-homepage-thank-you-donors"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('vgm-donor-marquee')) return;
  class VgmDonorMarquee extends HTMLElement {
    connectedCallback() {
      if (this.lifetime) return;
      this.lifetime = new AbortController();
      this.track = this.querySelector('.vgm-donor-track');
      this.source = this.querySelector('[data-donor-source]');
      this.copy = this.querySelector('[data-donor-copy]');
      this.originals = Array.from(this.source.children).filter(item => !item.hasAttribute('data-donor-repeat'));
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.setAttribute('data-enhanced', '');
      this.observer = new ResizeObserver(() => this.schedule());
      this.observer.observe(this);
      this.originals.forEach(item => {
        this.observer.observe(item);
        item.querySelector('img')?.addEventListener('load', () => this.schedule(), { signal: this.lifetime.signal });
      });
      this.reduced.addEventListener('change', () => this.schedule(), { signal: this.lifetime.signal });
      this.visible = false;
      this.visibility = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.syncPlayback();
      }, { rootMargin: '150px' });
      this.visibility.observe(this);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal: this.lifetime.signal });
      this.schedule();
    }
    syncPlayback() {
      if (this.visible && !document.hidden) this.animation?.play();
      else this.animation?.pause();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.animation?.cancel();
      this.observer?.disconnect();
      this.visibility?.disconnect();
      this.lifetime?.abort();
      this.lifetime = null;
      this.frame = 0;
      this.animation = null;
      this.layoutKey = null;
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; if (this.isConnected) this.layout(); });
    }
    layout() {
      const viewport = this.clientWidth;
      if (!viewport || !this.originals.length) return;
      const gap = parseFloat(getComputedStyle(this.source).columnGap) || 0;
      const style = getComputedStyle(this.source);
      const unit = this.originals.reduce((width, item) => width + item.getBoundingClientRect().width, 0) + gap * (this.originals.length - 1) + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      if (!unit) return;
      const seconds = parseFloat(getComputedStyle(this.closest('[data-vgm-donor-banner]')).getPropertyValue('--vgm78-donor-duration')) || 28;
      const repeats = Math.max(1, Math.ceil(viewport / unit));
      const key = [unit, repeats, seconds, this.reduced.matches].join(':');
      if (key === this.layoutKey) return;
      const position = this.animation ? new DOMMatrixReadOnly(getComputedStyle(this.track).transform).m41 : 0;
      const phase = this.unit ? ((position % this.unit) + this.unit) % this.unit / this.unit : 0;
      this.animation?.cancel();
      this.animation = null;
      this.source.querySelectorAll('[data-donor-repeat]').forEach(item => item.remove());
      this.copy.replaceChildren();
      if (!this.reduced.matches) {
        for (let repeat = 1; repeat < repeats; repeat++) {
          this.originals.forEach(item => {
            const clone = item.cloneNode(true);
            clone.setAttribute('data-donor-repeat', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelector('img')?.setAttribute('alt', '');
            this.source.append(clone);
          });
        }
        this.copy.append(...Array.from(this.source.children, item => {
          const clone = item.cloneNode(true);
          clone.querySelector('img')?.setAttribute('alt', '');
          return clone;
        }));
        const distance = this.source.getBoundingClientRect().width;
        const duration = seconds * 1000 * distance / unit;
        this.animation = this.track.animate([
          { transform: 'translate3d(' + -distance + 'px,0,0)' },
          { transform: 'translate3d(0,0,0)' }
        ], { duration, iterations: Infinity, easing: 'linear' });
        this.animation.currentTime = phase * seconds * 1000;
        this.syncPlayback();
      }
      this.unit = unit;
      this.layoutKey = key;
    }
  }
  customElements.define('vgm-donor-marquee', VgmDonorMarquee);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vgm-promo-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vgm-promo-banner')) {
    customElements.define('vgm-promo-banner', class extends HTMLElement {
      connectedCallback() {
        const update = () => {
          if (!this.isConnected) return;
          document.documentElement.style.setProperty('--vgm-promo-banner-height', `${this.offsetHeight}px`);
        };
        this.observer = new ResizeObserver(update);
        this.observer.observe(this);
        const hero = document.querySelector('[data-vgm-hero-phase]');
        const releaseOpening = () => {
          if (!hero || hero.dataset.vgmHeroPhase === 'detail') {
            document.documentElement.removeAttribute('data-vgm-promo-opening');
            document.documentElement.style.removeProperty('--vgm-promo-reveal');
          }
        };
        this.heroObserver = new MutationObserver(releaseOpening);
        if (hero) this.heroObserver.observe(hero, { attributes: true, attributeFilter: ['data-vgm-hero-phase'] });
        releaseOpening();
        update();
      }
      disconnectedCallback() {
        this.observer.disconnect();
        this.heroObserver.disconnect();
        document.documentElement.style.removeProperty('--vgm-promo-banner-height');
        document.documentElement.style.removeProperty('--vgm-promo-reveal');
        document.documentElement.removeAttribute('data-vgm-promo-opening');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
